import { Injectable, Injector } from '@angular/core';
import {
  Headers,
  Http,
  RequestOptionsArgs,
  Response,
  ResponseContentType,
  URLSearchParams
} from '@angular/http';
import { Router } from '@angular/router';
import * as moment from 'moment';
import { Subject } from 'rxjs';
import { BehaviorSubject, Observable } from 'rxjs/Rx';
import { apiUrlcommon } from '../../app.config';
import { car } from '../../models/plan/car';
import creditCompanyMap from '../../models/plan/creditCompanyMap';
import { Customer } from '../../models/plan/customer';
import { CustomerKubun } from '../../models/plan/customerKubun';
import { DealerOptions } from '../../models/plan/dealer-options.model';
import { EnvironmentSetting } from '../../models/plan/environmentSetting';
import { Kyoten } from '../../models/plan/kyoten.model';
import { Load } from '../../models/plan/loan';
import { Plancusotomer } from '../../models/plan/plancustomer';
import { PlanStock } from '../../models/plan/planstock';
import { PlanType } from '../../models/plan/plantype';
import { RecycleFeeDetail } from '../../models/plan/recycleFeeDetail';
import {
  selectSoukou,
  Shitadori,
  ShitadoriKBN
} from '../../models/plan/shitadori';
import { WebCreditData } from '../../models/plan/webcredit';
import { Zaiko } from '../../models/plan/zaiko';
import { DataService } from '../../services/data.service';
import { convertAddress } from '../interface/convertAddress';
import { gengokbn } from '../interface/gengokbn';
import { Prefectures } from '../interface/prefectures';
import { Questionnaire } from '../interface/questionnaire';
import { apiUrl } from './../../app.config';
import { Basic } from './../../models/plan/basic';
import { Basicchumon } from './../../models/plan/basicchumon';
import { CompanyPrintInfo } from './../../models/plan/companyInfo';
import { CustomerCar } from './../../models/plan/customerCar';
import { Dop } from './../../models/plan/dop';
import { EstimatesItem } from './../../models/plan/estimatesItem';
import { Etc } from './../../models/plan/etc';
import { hanbaitenOption } from './../../models/plan/hanbaitenOption';
import { Hop } from './../../models/plan/hop';
import { Kyotens } from './../../models/plan/kyotens';
import { MitsumoriItems } from './../../models/plan/mitsumoriItems';
import { ItemsMop, Mop } from './../../models/plan/mop';
import { OrderItems, Resultlist } from './../../models/plan/orderItems';
import { PlanCusotomerChumon } from './../../models/plan/plancusotomerchumon';
import { PurchaseItem } from './../../models/plan/purchaseItem.model';
import { Recycle } from './../../models/plan/recycle';
import { Saveapi } from './../../models/plan/saveapi';
import { Savechumon } from './../../models/plan/savechumon';
import { SavedialogOrder } from './../../models/plan/savedialogOrder';
import { Savedialogstate } from './../../models/plan/savedialogstate';
import {
  Customersearch,
  ResultslistCustomer
} from './../../models/plan/searchcustomer';
import { Car1, Car2 } from './../../models/plan/shitadori';
import { ShohiyouHikazeiSave } from './../../models/plan/shohiyouHikazeiSave';
import { ShohiyouKazeiSave, itemsShohiyouKazei } from './../../models/plan/shohiyouKazeiSave';
import { Staffs } from './../../models/plan/staffs';
import { Tax } from './../../models/plan/tax';
import { Timeserver } from './../../models/plan/timeserver';
import { Total } from './../../models/plan/total';
import { ZaikoItems } from './../../models/plan/zaikoItems';
import { SearchCustomer } from './../../models/searchCustomer';
import { PlanService } from './../../services/plan.service';
import { juuryouzei } from './../interface/juuryouzei';
import { TaxTable } from './../interface/taxTable';
import { DefaultPayment } from '../../models/plan/defaultPayment';
import { ShohiyoHikazei } from '../../models/plan/ShohiyoHikazei';
import { ShohiyouKazei } from '../../models/plan/companylist.model';
import { UtilService } from '../../services/util.service';
export interface Zn {
  zeinuki: number;
}
export interface Zk {
  zeikomi: number;
}
@Injectable()
export class PlanMainService {
  static headers = new Headers({ 'Content-Type': 'application/json' });
  public prefCd: number;

  public defaultHeaders: Headers = new Headers();
  public statusgradeCar: number = null;

  public urlPath: any[] = [];

  public makerClound: any[] = [];
  public makerCloundKbn: any[] = [];

  chosenDataRecycling = new BehaviorSubject<Recycle>(null);
  chosenDataTrade = new BehaviorSubject<any>('');
  menuAutho = new BehaviorSubject<any>(null);
  setSaleEdit = new BehaviorSubject<any>('');
  chosenClearState = new BehaviorSubject<any>('');
  // totlerecycling = new BehaviorSubject<any>('');
  setHunbaiOptionSelected = new BehaviorSubject<any>(null);
  setPlanHunbai = new BehaviorSubject<any>('');
  setPlanDealer = new BehaviorSubject<any>('');

  // usecarservice = new BehaviorSubject<car>(null);
  tradeinvalue = new BehaviorSubject<Shitadori>(null);
  taxvaluedata = new BehaviorSubject<Tax>(null);
  recycledata = new BehaviorSubject<Recycle>(null);
  customersData = new BehaviorSubject<Customer>(null);

  tadeincar = new BehaviorSubject<Car1>(null);
  tadeincar2 = new BehaviorSubject<Car2>(null);
  valueselect = new BehaviorSubject<selectSoukou>(null);
  valueselect2 = new BehaviorSubject<selectSoukou>(null);
  valueRecycletadein = new BehaviorSubject<Recycle>(null);
  valueRecycletadein2 = new BehaviorSubject<Recycle>(null);

  dealerOption = new BehaviorSubject<DealerOptions[]>(null);
  dopdealarvalue = new BehaviorSubject<any>(null);
  doploanflags = new BehaviorSubject<any>([]);
  doploanflags2 = new BehaviorSubject<any>([]);
  dopSave = new BehaviorSubject<any>([]);
  dopSave2 = new BehaviorSubject<any>([]);
  doploanNotSave = new BehaviorSubject<any>(null);
  consumptiontax = new BehaviorSubject<number>(80);
  savadataPlan = new BehaviorSubject<Plancusotomer>(null);
  hanbaitenOptions = new BehaviorSubject<hanbaitenOption[]>(null);
  datahopvalue = new BehaviorSubject<Hop>(null);
  datamop = new BehaviorSubject<any>(null);
  listdatacustomers = new BehaviorSubject<ResultslistCustomer>(null);
  datapurchaseSearch = new BehaviorSubject<Resultlist>(null);
  savedatachumon = new BehaviorSubject<PlanCusotomerChumon>(null);
  addTotal = new BehaviorSubject<Total>(null);
  shohiyouHikazeiSave = new BehaviorSubject<ShohiyouHikazeiSave>(null);
  leaseShohiyouHikazeiSave = new BehaviorSubject<ShohiyouHikazeiSave>(null);
  loandata = new BehaviorSubject<Load>(null);
  shohiyouKazeiSave = new BehaviorSubject<ShohiyouKazeiSave>(null);
  leaseShohiyouKazeiSave = new BehaviorSubject<ShohiyouKazeiSave>(null);
  public dataCustomer: BehaviorSubject<Customer> = new BehaviorSubject(null);
  public dataetc: BehaviorSubject<Etc> = new BehaviorSubject(null);

  valuesumitemshutokuzei = new BehaviorSubject(0);
  valueSumshutokuzeiMaker = new BehaviorSubject(0);
  valueSumshutokuzeiMaker2 = new BehaviorSubject(0);
  valueSumshutokuzeiMaker3 = new BehaviorSubject(0);
  valueSumshutokuzeiHop = new BehaviorSubject(0);
  valueSumshutokuzeiHop2 = new BehaviorSubject(0);
  valueSumshutokuzeiHop3 = new BehaviorSubject(0);
  addmakerOption = new BehaviorSubject<any>(null);

  basicserviceobj = new BehaviorSubject<Basic>(null);
  basicOrders = new BehaviorSubject<Basicchumon>(null);

  taxValueselect = new BehaviorSubject<any>(null);
  statusGrade = new BehaviorSubject<number>(1);

  resetvalue = new BehaviorSubject<any>(null);
  staffDialog = new BehaviorSubject<any>(null);
  staffDialogCallback = new BehaviorSubject<any>(null);
  menuAuthoCallback = new BehaviorSubject<any>(null);

  totalTax = new BehaviorSubject<any>(null);
  recalTotalTax = new Subject();
  hanbaiOption = new BehaviorSubject<any>(null);

  ResponseStatus;

  public mitsumoriCdBasic: any;
  public chumonCdBasic: any;

  public dataenviroment: EnvironmentSetting;
  public makerOptionSum: any;

  public isShowInquiry1: boolean = false;
  public isShowInquiry2: boolean = false;

  public pageselect = new BehaviorSubject<any>({ page: 2, status: null });

  public getloanplan = new BehaviorSubject<Load>(null);
  public hopShowDialog = new BehaviorSubject<boolean>(false);
  public isPageLogin = new BehaviorSubject<string>('');
  public stockdetail = new BehaviorSubject<PlanStock>(null);
  public paymentondata: any;
  private _hasLeaseData = false;
  get hasLeaseData(): boolean {
    return this._hasLeaseData;
  }
  set hasLeaseData(value: boolean) {
    this._hasLeaseData = value;
  }

  public isUpdateCustomer = false;
  // public customerSaved: Customer;
  public firstpaymentloan = new BehaviorSubject<boolean>(true);
  public isOsusume = false;
  public isPlanFromBusinessManage = false;
  public chosenKanriNo = new BehaviorSubject<string>('');

  public remarkBikou1_1: Kyoten;
  public remarkBikou1_2: Kyoten;
  public remarkBikou2_1: Kyoten;
  public remarkBikou2_2: Kyoten;
  public remarkBikou3_1: Kyoten;
  public remarkBikou3_2: Kyoten;

  public etc1: Etc = {};
  public etc2: Etc = {};
  public etc3: Etc = {};

  public isSavedKazei = false;
  public isSavedHikazei = false;
  public planType: PlanType = new PlanType();
  public allFlags1: any;
  public allFlags2: any;
  public allFlags3: any;

  public defaultPaymentSetting = new BehaviorSubject<DefaultPayment>(null);
  public warningshakenKigen = new Subject();
  public clearShitadoriSubject = new Subject();

  public isWaitingKouchin = false;
  public confirmDopSubject = new Subject();
  public saveSubject = new Subject();
  public updatePaymentSubject = new BehaviorSubject<number>(0);
  public stockSelected = new BehaviorSubject<any>(null);
  public isEditTaxShutokuzei = false;
  public noGradeList = false;

  /** 2021-07-08 sh #7269 if change hontai-price, it needs to call re-get init. [START] */
  isEditHontaiPrice = new BehaviorSubject<number>(0);
  /** 2021-07-08 sh #7269 if change hontai-price, it needs to call re-get init. [END] */

  constructor(
    private _http: Http,
    private router: Router,
    private injector: Injector,
    private planservice: PlanService,
    private _data: DataService, // private planInternalSv: PlanInternalService
    private _util: UtilService,
  ) { }

  setstockdetail(data: PlanStock) {
    this.stockdetail.next({ ...data });
  }

  setMakerClound(val: any[]) {
    // console.log('setMkdata', val);
    this.makerClound = [...val];
  }

  getMakerClound() {
    // console.log('getMkdata', this.makerClound);s
    return [...this.makerClound];
  }

  setMakerCloundKbn(val: any[]) {
    this.makerCloundKbn = [...val];
  }

  getMakerCloundKbn() {
    return this.makerCloundKbn;
  }

  setLoanData(data: Load) {
    if (data) {
      data = { ...data };
    }
    this.loandata.next(data);
  }

  setbasicserviceobj(data: Basic) {
    this.basicserviceobj.next(Object.assign({}, data));
  }

  setbasicOrders(data: Basicchumon) {
    this.basicOrders.next(Object.assign({}, data));
  }

  setresetvalue(value) {
    this.resetvalue.next(value);
  }

  setstatusGradeCar(value) {
    this.statusgradeCar = value;
    this.statusGrade.next(value);
  }

  getstatusGradeCar() {
    return this.statusgradeCar;
  }

  setaddTaxSelect(value) {
    this.taxValueselect.next(value);
  }

  setaddmakerOption(data: ItemsMop[]) {
    this.addmakerOption.next(Object.assign([], data));
  }

  setDataHop(data: Hop) {
    this.datahopvalue.next(Object.assign({}, data));
  }

  //▽[pl2021-41]add
  // 販売店OP情報一式を得る
  getDataHop():Hop {
    return this.datahopvalue.getValue();
  }
  //△[pl2021-41]add

  setpurchaseSearch(data: Resultlist) {
    this.datapurchaseSearch.next(Object.assign({}, data));
  }

  setDataQuotationCustomers(data: ResultslistCustomer) {
    this.listdatacustomers.next(Object.assign({}, data));
  }

  setDataCustomer(data: Customer) {
    this.dataCustomer.next(Object.assign({}, data));
  }

  setEtc(data: Etc) {
    this.dataetc.next(Object.assign({}, data));
  }

  setpaymentdata(data) {
    this.paymentondata = data;
  }

  getpaymentdata() {
    return this.paymentondata;
  }

  getDataQuotationCustomers() {
    this.listdatacustomers
      .subscribe(val => {
        console.log(val);
        return val;
      })
      .unsubscribe();
  }

  setdateMop(data: Mop) {
    this.datamop.next(Object.assign({}, data));
  }
  
  //▽[pl2021-41]add
  // メーカーOP情報一式を得る
  getDataMop():Mop {
    return this.datamop.getValue();
  }
  //△[pl2021-41]add

  sethanbaitenOption(data: hanbaitenOption[]) {
    this.hanbaitenOptions.next(Object.assign([], data));
  }

  setDataFromRecycling(data: Recycle) {
    this.chosenDataRecycling.next(Object.assign({}, data));
  }

  // settotlerecycling(data: any) {
  //   this.totlerecycling.next(data);
  // }

  adddatasavePlan(data: any) {
    this.savadataPlan.next(Object.assign({}, data));
  }

  addtradeinData(data: Shitadori) {
    this.tradeinvalue.next(Object.assign({}, data));
  }

  addvalueRecycletadein(data: Recycle) {
    this.valueRecycletadein.next(Object.assign({}, data));
  }

  addvalueRecycletadein2(data: Recycle) {
    this.valueRecycletadein2.next(Object.assign({}, data));
  }

  addTaxValue(data: Tax) {
    this.taxvaluedata.next(Object.assign({}, data));
  }

  adddopdealarvalue(data: Dop) {
    this.dopdealarvalue.next(Object.assign({}, data));
  }

  //▽[pl2021-41]add
  // ディーラーOP情報一式を得る
  getDataDop():Dop {
    return this.dopdealarvalue.getValue();
  }
  //△[pl2021-41]add

  addDealerOption(data: DealerOptions[]) {
    this.dealerOption.next(Object.assign({}, data));
  }

  addRecycledata(data: Recycle) {
    this.recycledata.next(Object.assign({}, data));
  }

  setDataFromPlanTrade(data: any) {
    this.chosenDataTrade.next(data);
  }

  addSelectSoukou(data: selectSoukou) {
    this.valueselect.next(Object.assign({}, data));
  }

  addSelectSoukou2(data: selectSoukou) {
    this.valueselect2.next(Object.assign({}, data));
  }

  setDatatadeincar(data: Car1) {
    this.tadeincar.next(Object.assign({}, data));
  }

  setDatatadeincar2(data: Car2) {
    this.tadeincar2.next(Object.assign({}, data));
  }

  setCustomer(data: Customer) {
    this.customersData.next(Object.assign({}, data));
  }

  // setDatauseCar(data: car) {
  //   // console.log(data)
  //   this.usecarservice.next(Object.assign({}, data));
  //   //  this.usecarservice.complete();
  // }

  // setcompleteGetValue() {
  //   this.usecarservice.complete();
  // }

  setClearState(state: any) {
    this.chosenClearState.next(state);
  }

  setMenuAutho(res: any) {
    this.menuAutho.next(Object.assign({}, res));
  }

  addConsumptiontax(data: number) {
    this.consumptiontax.next(data);
  }

  settotal(data: Total) {
    this.addTotal.next(Object.assign({}, data));
  }

  addsavechumon(data: PlanCusotomerChumon) {
    this.savedatachumon.next(Object.assign({}, data));
  }

  setmitsumoriCdBasic(data) {
    this.mitsumoriCdBasic = data;
  }

  getmitsumoriCdBasic() {
    return this.mitsumoriCdBasic;
  }

  setchumonCdBasic(data) {
    this.chumonCdBasic = data;
  }

  getchumonCdBasic() {
    return this.chumonCdBasic;
  }

  getMenuAuthority() {
    const path = `${apiUrl}` + `/staff/menuAuthority`;
    const queryParameters = new URLSearchParams();
    const headerParams = this.defaultHeaders;
    headerParams.set('auth', this._data.token);
    const requestOptions: RequestOptionsArgs = {
      headers: headerParams,
      search: queryParameters
    };
    return this._http
      .get(path, requestOptions)
      .map((response: Response) => {
        if (response.status === 204) {
          // return undefined;
          return { status: 204 }; // this.httpGet(path);
        } else if (response.status === 401) {
          this.deleteToken();
        } else {
          return response.json();
        }
      })
      .catch(this.handleError.bind(this));
  }

  getPrefectures(): Observable<Prefectures[]> {
    const path = `${apiUrlcommon}` + `/etc/prefectures`;
    const queryParameters = new URLSearchParams();
    const headerParams = this.defaultHeaders;
    headerParams.set('auth', this._data.token);
    const requestOptions: RequestOptionsArgs = {
      method: 'GET',
      headers: headerParams,
      search: queryParameters
    };
    return this._http
      .request(path, requestOptions)
      .map((response: Response) => {
        if (response.status === 204) {
          return undefined;
        } else if (response.status == 401) {
          this.deleteToken();
        } else {
          return response.json();
        }
      })
      .catch(this.handleError.bind(this));
  }

  setStringdate(formetdate: any, date: any): string {
    return moment(date).format(formetdate);
  }

  getDate(date: any, formetdate: any): Date {
    const myDate: Date = moment(date, formetdate).toDate();
    return myDate;
  }

  getshitadoriKbn(): Observable<ShitadoriKBN[]> {
    const path = `${apiUrlcommon}` + `/etc/kbn/shitadoriKbn`;
    const queryParameters = new URLSearchParams();
    const headerParams = this.defaultHeaders;
    headerParams.set('auth', this._data.token);
    const requestOptions: RequestOptionsArgs = {
      method: 'GET',
      headers: headerParams,
      search: queryParameters
    };
    return this._http
      .request(path, requestOptions)
      .map((response: Response) => {
        if (response.status === 204) {
          return undefined;
        } else {
          return response.json();
        }
      })
      .share()
      .catch(this.handleError.bind(this));
  }

  getCustomerKubun(): Observable<CustomerKubun[]> {
    const path = `${apiUrlcommon}` + `/etc/kbn/kokyaku`;
    const queryParameters = new URLSearchParams();
    const headerParams = this.defaultHeaders;
    headerParams.set('auth', this._data.token);
    const requestOptions: RequestOptionsArgs = {
      method: 'GET',
      headers: headerParams,
      search: queryParameters
    };
    // console.log(path);
    return this._http
      .request(path, requestOptions)
      .map((response: Response) => {
        if (response.status === 204) {
          return undefined;
        } else if (response.status == 401) {
          this.deleteToken();
        } else {
          return response.json();
        }
      })
      .catch(this.handleError.bind(this));
  }

  getSoukouUnit(): Observable<any[]> {
    const path = `${apiUrlcommon}` + `/etc/kbn/soukouUnitKbn`;
    const queryParameters = new URLSearchParams();
    const headerParams = this.defaultHeaders;
    headerParams.set('auth', this._data.token);
    const requestOptions: RequestOptionsArgs = {
      method: 'GET',
      headers: headerParams,
      search: queryParameters
    };
    return this._http
      .request(path, requestOptions)
      .map((response: Response) => {
        if (response.status === 204) {
          return undefined;
        } else if (response.status == 401) {
          this.deleteToken();
        } else {
          return response.json();
        }
      })
      .catch(this.handleError.bind(this));
  }

  getSoukouBikou(): Observable<any[]> {
    const path = `${apiUrlcommon}` + `/etc/kbn/soukouBikouKbn`;
    const queryParameters = new URLSearchParams();
    const headerParams = this.defaultHeaders;
    headerParams.set('auth', this._data.token);
    const requestOptions: RequestOptionsArgs = {
      method: 'GET',
      headers: headerParams,
      search: queryParameters
    };
    return this._http
      .request(path, requestOptions)
      .map((response: Response) => {
        if (response.status === 204) {
          return undefined;
        } else if (response.status == 401) {
          this.deleteToken();
        } else {
          return response.json();
        }
      })
      .catch(this.handleError.bind(this));
  }

  getStaxhutokuzei(
    nenshiki: string,
    registCarYm: string,
    isKeiCar: string,
    shutokuzeiKoujoGaku: string
  ): Observable<any> {
    const path =
      `${apiUrlcommon}` +
      `/tax/shutokuzei/getCurrentTax?q=nenshiki%3D${nenshiki},registCarYm%3D${registCarYm},isKeiCar%3D${isKeiCar},shutokuzeiKoujoGaku%3D${shutokuzeiKoujoGaku}`;
    const queryParameters = new URLSearchParams();
    const headerParams = this.defaultHeaders;
    headerParams.set('auth', this._data.token);
    const requestOptions: RequestOptionsArgs = {
      method: 'GET',
      headers: headerParams,
      search: queryParameters
    };
    return this._http
      .request(path, requestOptions)
      .map((response: Response) => {
        if (response.status === 204) {
          return undefined;
        } else if (response.status == 401) {
          this.deleteToken();
        } else {
          return response.json();
        }
      })
      .catch(this.handleError.bind(this));
  }

  savaDataAll(data: Saveapi): Observable<Plancusotomer> {
    const path = `${apiUrl}` + `/estimates`;
    // const path = `http://192.168.1.56:19401/ckj/v1` + `/estimates`
    // const path = `http://192.168.1.56:19401` + `/estimates`;

    const queryParameters = new URLSearchParams();
    // this.defaultHeaders.append('Content-Type', 'application/json;charset=utf-8');
    const headerParams = this.defaultHeaders;
    headerParams.set('auth', this._data.token);
    headerParams.set('Content-Type', 'application/json;charset=utf-8');
    headerParams.set('Accept', 'application/json');
    const value = JSON.stringify(data);
    const requestOptions: RequestOptionsArgs = {
      method: 'POST',
      headers: headerParams,
      body: value,
      search: queryParameters
    };
    console.log(requestOptions);
    return this._http
      .request(path, requestOptions)
      .map((response: Response) => {
        if (response.status === 204) {
          return undefined;
        } else if (response.status == 401) {
          this.deleteToken();
        } else {
          return response.json();
        }
      })
      .catch(this.handleError.bind(this));
  }

  getconvertZipToAddress(
    zipcodeFirst: string,
    zipcodeSecond: string
  ): Observable<convertAddress[]> {
    let path = '';
    if (zipcodeSecond != null && zipcodeSecond != undefined) {
      path =
        `${apiUrlcommon}` +
        `/etc/zipCode/convertZipToAddress?q=zipcodeFirst%3D${zipcodeFirst},zipcodeSecond%3D${zipcodeSecond},prefFlag%3D0`;
    } else {
      path =
        `${apiUrlcommon}` +
        `/etc/zipCode/convertZipToAddress?q=zipcodeFirst%3D${zipcodeFirst},prefFlag%3D0`;
    }
    const queryParameters = new URLSearchParams();
    const headerParams = this.defaultHeaders;
    headerParams.set('auth', this._data.token);
    const requestOptions: RequestOptionsArgs = {
      method: 'GET',
      headers: headerParams,
      search: queryParameters
    };
    return this._http
      .request(path, requestOptions)
      .map((response: Response) => {
        if (response.status === 204) {
          return undefined;
        }
        //  else if (response.status == 401) {
        //   this.deleteToken();
        // }
        else {
          return response.json();
        }
      })
      .catch(this.handleError.bind(this));
  }

  getgengoKbn(): Observable<gengokbn[]> {
    const path = `${apiUrlcommon}` + `/etc/kbn/gengoKbn`;
    const queryParameters = new URLSearchParams();
    const headerParams = this.defaultHeaders;
    headerParams.set('auth', this._data.token);
    const requestOptions: RequestOptionsArgs = {
      method: 'GET',
      headers: headerParams,
      search: queryParameters
    };
    return this._http
      .request(path, requestOptions)
      .map((response: Response) => {
        if (response.status === 204) {
          return undefined;
        } else {
          return response.json();
        }
      })
      .share()
      .catch(this.handleError.bind(this));
  }

  getPersonAge(date: any) {
    const headerParams = this.defaultHeaders;
    headerParams.set('auth', this._data.token);
    return this._http
      .get(`${apiUrlcommon}/etc/person/age/${date}`, { headers: headerParams })
      .map(response => response.json());
  }

  getGender() {
    const headerParams = this.defaultHeaders;
    headerParams.set('auth', this._data.token);
    return this._http
      .get(`${apiUrlcommon}/etc/kbn/gender`, { headers: headerParams })
      .map(response => response.json());
  }

  getAddress(
    converaddress: Prefectures,
    addressParams
  ): Observable<convertAddress[]> {
    const prefnameencode: string = encodeURIComponent(converaddress.prefNm);
    const prefaddressencode: string = encodeURIComponent(addressParams);

    const path =
      `${apiUrlcommon}` +
      `/etc/zipCode/convertAddressToZip?q=prefName=${prefnameencode}`;
    // `/etc/zipCode/convertAddressToZip?q=prefName%3D${prefnameencode}`;

    const pathwithaddress = `${path},address=${prefaddressencode}`;

    let URL = path;
    if (!addressParams || addressParams === '' || addressParams === null) {
      URL = path;
    } else {
      URL = pathwithaddress;
    }

    const queryParameters = new URLSearchParams();
    const headerParams = this.defaultHeaders;
    headerParams.set('auth', this._data.token);
    const requestOptions: RequestOptionsArgs = {
      method: 'GET',
      headers: headerParams,
      search: queryParameters
    };
    return this._http
      .request(URL, requestOptions)
      .map((response: Response) => {
        if (response.status === 204) {
          return undefined;
        }
        // else if (response.status == 401) {
        //   this.deleteToken();
        // }
        else {
          return response.json();
        }
      })
      .catch(this.handleError.bind(this));
  }

  getKubuns(): Observable<juuryouzei> {
    const path = `${apiUrlcommon}` + `/tax/juuryouzei/kubuns`;
    const queryParameters = new URLSearchParams();
    const headerParams = this.defaultHeaders;
    const requestOptions: RequestOptionsArgs = {
      method: 'GET',
      headers: headerParams,
      search: queryParameters
    };
    return this._http
      .request(path, requestOptions)
      .map((response: Response) => {
        if (response.status === 204) {
          return undefined;
        } else if (response.status == 401) {
          this.deleteToken();
        } else {
          return response.json();
        }
      })
      .catch(this.handleError.bind(this));
  }

  gettaxTable(value: any, date: string): Observable<TaxTable> {
    const path = `${apiUrlcommon}/tax/juuryouzei/taxTable?q=kazeiKbn%3D${value},targetDate%3D${date}`;
    const queryParameters = new URLSearchParams();
    const headerParams = this.defaultHeaders;
    const requestOptions: RequestOptionsArgs = {
      method: 'GET',
      headers: headerParams,
      search: queryParameters
    };
    return this._http
      .request(path, requestOptions)
      .map((response: Response) => {
        if (response.status === 204) {
          return undefined;
        } else if (response.status == 401) {
          this.deleteToken();
        } else {
          return response.json();
        }
      })
      .catch(this.handleError.bind(this));
  }

  getPDFSaveapi(
    value: any,
    leaseNo: any,
    payWay: any,
    printcompanyCd?: any,
    ImageForprint?: any[],
    numberOfCopies?: number
  ): Observable<any> {
    let prefCdVal;
    let path;
    if (this.prefCd == null) {
      prefCdVal = 6;
    } else {
      prefCdVal = this.prefCd;
    }

    if (payWay === 3) {
      path =
        `${apiUrl}` + `/estimates/${value}/leasePlan/${leaseNo}/clvNormalPdf?q=prefCd%3D${prefCdVal}`;
    } else {
      path = `${apiUrl}` + `/estimates/${value}/pdf?q=prefCd%3D${prefCdVal}`;

    if (ImageForprint) {
      path = path + `,carImageNumbers%3D${ImageForprint}`;
    }

    if (numberOfCopies) {
      path = path + `,numberOfCopies%3D${numberOfCopies}`;
    }
  }

  if (printcompanyCd) {
    path = path + `,insatsuKaishaCd%3D${printcompanyCd}`;
  }

    return this._http
      .get(path, {
        headers: this.defaultHeaders,
        responseType: ResponseContentType.Blob
      })
      .map(response => response.blob())
      .catch(this.handleError.bind(this));
  }

  getPDFChumonapi(
    value: any,
    leaseNo: any,
    payWay: any,
    printcompanyCd?,
    invoiceModeBool?: boolean,
    numberOfCopies?: number
  ): Observable<any> {
    let prefCdVal;
    let path;
    if (this.prefCd == null) {
      prefCdVal = 6;
    } else {
      prefCdVal = this.prefCd;
    }

    let invoiceMode = 0;
    if (invoiceModeBool) {
      invoiceMode = 1;
    }
    // if (leaseNo) {
    //   console.log('getPDFChumonapi', leaseNo, payWay);
    // }

    // const path = `${apiUrl}` + `/orders/${value}/pdf?q=prefCd%3D${prefCdVal}`;

    if (payWay === 3) {
      path = `${apiUrl}` + `/orders/${value}/leasePlan/${leaseNo}/clvNormalPdf?q=prefCd%3D${prefCdVal}`;
    } else {
      path = `${apiUrl}` + `/orders/${value}/pdf?q=prefCd%3D${prefCdVal},invoiceMode=${invoiceMode}`;
      if (numberOfCopies) {
        path = path + `,numberOfCopies%3D${numberOfCopies}`;
      }
    }
    if (printcompanyCd) {
      path = path + `,insatsuKaishaCd%3D${printcompanyCd}`;
    }

    return this._http
      .get(path, {
        headers: this.defaultHeaders,
        responseType: ResponseContentType.Blob
      })
      .map(response => response.blob())
      .catch(this.handleError.bind(this));
  }

  getPdfMitsuFromOrderApi(
    chumonNo: any,
    printcompanyCd?: any,
    ImageForprint?: any[]
  ): Observable<any> {
    let path;

    path = `${apiUrl}` + `/orders/${chumonNo}/estimatePdf/?q=`;

    if (printcompanyCd) {
      path = path + `,insatsuKaishaCd%3D${printcompanyCd}`;
    }

    if (ImageForprint) {
      path = path + `,carImageNumbers%3D${ImageForprint}`;
    }

    return this._http
      .get(path, {
        headers: this.defaultHeaders,
        responseType: ResponseContentType.Blob
      })
      .map(response => response.blob())
      .catch(this.handleError.bind(this));
  }

  gethanbaitenOptions(taxrate: any, hanbaitenOptionKbn: any): Observable<any> {
    const kyotenCd = localStorage.getItem('kyotenCd');
    let url = `/plan/hanbaitenOptions?q=taxRate=${taxrate},kyotenCd=${kyotenCd}`;
    if (hanbaitenOptionKbn) {
      url += `,hanbaitenOptionKbn=${hanbaitenOptionKbn}`;
    }
    const path = `${apiUrl}` + url;
    const queryParameters = new URLSearchParams();
    const headerParams = this.defaultHeaders;
    headerParams.set('auth', this._data.token);
    const requestOptions: RequestOptionsArgs = {
      method: 'GET',
      headers: headerParams,
      search: queryParameters
    };
    return this._http
      .request(path, requestOptions)
      .map((response: Response) => {
        if (response.status === 204) {
          return undefined;
        } else if (response.status == 401) {
          this.deleteToken();
        } else {
          return response.json();
        }
      });
    // .catch((this.handleError.bind(this)));
  }

  getkyotens(): Observable<Kyotens[]> {
    const path = `${apiUrl}` + `/kyotens`;
    const queryParameters = new URLSearchParams();
    const headerParams = this.defaultHeaders;
    headerParams.set('auth', this._data.token);
    const requestOptions: RequestOptionsArgs = {
      method: 'GET',
      headers: headerParams,
      search: queryParameters
    };
    return this._http
      .request(path, requestOptions)
      .map((response: Response) => {
        if (response.status === 204) {
          return undefined;
        } else if (response.status == 401) {
          this.deleteToken();
        } else {
          return response.json();
        }
      })
      .catch(this.handleError.bind(this));
  }

  getStaffs(kyotenCd: string): Observable<Staffs[]> {
    const path = `${apiUrl}` + `/staffs?q=kyotenCd%3D${kyotenCd}`;
    const queryParameters = new URLSearchParams();
    const headerParams = this.defaultHeaders;
    headerParams.set('auth', this._data.token);
    const requestOptions: RequestOptionsArgs = {
      method: 'GET',
      headers: headerParams,
      search: queryParameters
    };
    return this._http
      .request(path, requestOptions)
      .map((response: Response) => {
        if (response.status === 204) {
          return undefined;
        } else if (response.status == 401) {
          this.deleteToken();
        } else {
          return response.json();
        }
      })
      .catch(this.handleError.bind(this));
  }

  getStaffname(value?: string) {
    let path = `${apiUrl}` + `/staffs`;
    if (value) {
      path = `${apiUrl}` + `/staffs?q=kyotenCd%3D${value}`;
    }

    const queryParameters = new URLSearchParams();
    const headerParams = this.defaultHeaders;
    headerParams.set('auth', this._data.token);
    const requestOptions: RequestOptionsArgs = {
      method: 'GET',
      headers: headerParams,
      search: queryParameters
    };
    return this._http
      .request(path, requestOptions)
      .map((response: Response) => {
        if (response.status === 204) {
          return undefined;
        } else if (response.status == 401) {
          this.deleteToken();
        } else {
          return response.json();
        }
      })
      .catch(this.handleError.bind(this));
  }

  getCustomerCar(value: string): Observable<CustomerCar> {
    const path =
      `${apiUrl}` +
      `/plan/customerCars?q=customerNo%3D${value}&page=1&sort=customerNo&size=10`;
    const queryParameters = new URLSearchParams();
    const headerParams = this.defaultHeaders;
    headerParams.set('auth', this._data.token);
    const requestOptions: RequestOptionsArgs = {
      method: 'GET',
      headers: headerParams,
      search: queryParameters
    };
    return this._http
      .request(path, requestOptions)
      .map((response: Response) => {
        if (response.status === 204) {
          return undefined;
        } else if (response.status == 401) {
          this.deleteToken();
        } else {
          return response.json();
        }
      })
      .catch(this.handleError.bind(this));
  }

  // getOtherCar(value: string,
  SearchCar(
    customerPhoneCarPlateVariable: string = '',
    page: number = 1,
    size: number = 50
  ): Observable<CustomerCar> {
    // let path =
    //   `${apiUrl}` +
    //   `/plan/customerCars?q=ignoreCustomerNo%3D${value}&page=${page}&sort=customerNo&size=${size}`;
    // if (customerPhoneCarPlateVariable) {
    //   path +=
    //     '&customerPhoneCarPlateVariable=' +
    //     encodeURI(customerPhoneCarPlateVariable);
    // }
    const keyword = encodeURI(customerPhoneCarPlateVariable);
    const path = `${apiUrl}/plan/customerCars?q=customerPhoneCarPlateVariable=${keyword}&page=${page}&sort=customerNo&size=${size}`;
    const queryParameters = new URLSearchParams();
    const headerParams = this.defaultHeaders;
    headerParams.set('auth', this._data.token);
    const requestOptions: RequestOptionsArgs = {
      method: 'GET',
      headers: headerParams,
      search: queryParameters
    };
    return this._http
      .request(path, requestOptions)
      .map((response: Response) => {
        if (response.status === 204) {
          return null;
        } else if (response.status == 401) {
          this.deleteToken();
        } else {
          return response.json();
        }
      })
      .catch(this.handleError.bind(this));
  }

  getDateServerTime(): Observable<Timeserver> {
    const path = `${apiUrlcommon}/etc/serverTime`;
    const queryParameters = new URLSearchParams();
    const headerParams = this.defaultHeaders;
    headerParams.set('auth', this._data.token);
    const requestOptions: RequestOptionsArgs = {
      method: 'GET',
      headers: headerParams,
      search: queryParameters
    };
    return this._http
      .request(path, requestOptions)
      .map((response: Response) => {
        if (response.status === 204) {
          return undefined;
        } else if (response.status == 401) {
          this.deleteToken();
        } else {
          return response.json();
        }
      })
      .catch(this.handleError.bind(this));
  }

  getestimates(value: number): Observable<Saveapi> {
    const path = `${apiUrl}` + `/estimates/${value}`;
    // const path = `http://192.168.1.55:19401/ckj/v1` + `/estimates/${value}`;

    const queryParameters = new URLSearchParams();
    const headerParams = this.defaultHeaders;
    headerParams.set('auth', this._data.token);
    const requestOptions: RequestOptionsArgs = {
      method: 'GET',
      headers: headerParams,
      search: queryParameters
    };
    return this._http
      .request(path, requestOptions)
      .map((response: Response) => {
        if (response.status === 204) {
          return undefined;
        } else if (response.status == 401) {
          this.deleteToken();
        } else {
          return response.json();
        }
      })
      .catch(this.handleError.bind(this));
  }

  getOrderschumon(value: string): Observable<Savechumon> {
    const path = `${apiUrl}` + `/orders/${value}`;
    // const path = `${apiUrl}` + `/orders/${value}`;
    // const path = `http://192.168.1.55:19401/ckj/v1` + `/estimates/${value}`;

    const queryParameters = new URLSearchParams();
    const headerParams = this.defaultHeaders;
    headerParams.set('auth', this._data.token);
    const requestOptions: RequestOptionsArgs = {
      method: 'GET',
      headers: headerParams,
      search: queryParameters
    };
    return this._http
      .request(path, requestOptions)
      .map((response: Response) => {
        if (response.status === 204) {
          return undefined;
        } else if (response.status == 401) {
          this.deleteToken();
        } else {
          return response.json();
        }
      })
      .catch(this.handleError.bind(this));
  }

  getSaveChumon(data: Savechumon): Observable<PlanCusotomerChumon> {
    const path = `${apiUrl}` + `/orders`;
    const queryParameters = new URLSearchParams();
    // this.defaultHeaders.append('Content-Type', 'application/json;charset=utf-8');
    const headerParams = this.defaultHeaders;
    headerParams.set('auth', this._data.token);
    headerParams.set('Content-Type', 'application/json;charset=utf-8');
    headerParams.set('Accept', 'application/json');
    const value = JSON.stringify(data);
    const requestOptions: RequestOptionsArgs = {
      method: 'POST',
      headers: headerParams,
      body: value,
      search: queryParameters
    };
    console.log(requestOptions);
    return this._http
      .request(path, requestOptions)
      .map((response: Response) => {
        if (response.status === 204) {
          return undefined;
        } else if (response.status == 401) {
          this.deleteToken();
        } else {
          return response.json();
        }
      })
      .catch(this.handleError.bind(this));
  }

  updateestimates(data: Saveapi, id: string): Observable<any> {
    const path = `${apiUrl}` + `/estimates/${id}`;
    // const path = `http://192.168.1.55:19401/ckj/v1` + `/estimates/${id}`;
    const queryParameters = new URLSearchParams();
    this.defaultHeaders.append(
      'Content-Type',
      'application/json;charset=utf-8'
    );
    const headerParams = this.defaultHeaders;
    headerParams.set('auth', this._data.token);
    const value = JSON.stringify(data);
    const requestOptions: RequestOptionsArgs = {
      method: 'PUT',
      headers: headerParams,
      body: value,
      search: queryParameters
    };
    return this._http
      .request(path, requestOptions)
      .map((response: Response) => {
        if (response.status === 204) {
          return undefined;
        } else if (response.status == 401) {
          this.deleteToken();
        } else {
          return response.json();
        }
      })
      .catch(this.handleError.bind(this));
  }

  updateOrders(data: Savechumon, id: string): Observable<any> {
    const path = `${apiUrl}` + `/orders/${id}`;
    // const path = `http://192.168.1.55:19401/ckj/v1` + `/estimates/${id}`;
    const queryParameters = new URLSearchParams();
    this.defaultHeaders.append(
      'Content-Type',
      'application/json;charset=utf-8'
    );
    const headerParams = this.defaultHeaders;
    headerParams.set('auth', this._data.token);
    const value = JSON.stringify(data);
    const requestOptions: RequestOptionsArgs = {
      method: 'PUT',
      headers: headerParams,
      body: value,
      search: queryParameters
    };
    return this._http
      .request(path, requestOptions)
      .map((response: Response) => {
        if (response.status === 204) {
          return undefined;
        } else if (response.status == 401) {
          this.deleteToken();
        } else {
          return response.json();
        }
      })
      .catch(this.handleError.bind(this));
  }

  getoptionKubuns(): Observable<any> {
    const path = `${apiUrl}` + `/plan/hanbaitenOptions/optionKubuns`;
    // const path = `http://192.168.1.55:19401/ckj/v1` + `/estimates/${id}`;
    const queryParameters = new URLSearchParams();
    this.defaultHeaders.append(
      'Content-Type',
      'application/json;charset=utf-8'
    );
    const headerParams = this.defaultHeaders;
    headerParams.set('auth', this._data.token);
    const requestOptions: RequestOptionsArgs = {
      method: 'GET',
      headers: headerParams,
      search: queryParameters
    };
    return this._http
      .request(path, requestOptions)
      .map((response: Response) => {
        if (response.status === 204) {
          return undefined;
        } else if (response.status == 401) {
          this.deleteToken();
        } else {
          return response.json();
        }
      })
      .catch(this.handleError.bind(this));
  }

  getcompanyInfoListForPrint(value: any): Observable<CompanyPrintInfo[]> {
    const path = `${apiUrl}` + `/estimates/${value}/companyInfoListForPrint`;
    // const path = `http://192.168.1.55:19401/ckj/v1` + `/estimates/${id}`;
    const queryParameters = new URLSearchParams();
    this.defaultHeaders.append(
      'Content-Type',
      'application/json;charset=utf-8'
    );
    const headerParams = this.defaultHeaders;
    headerParams.set('auth', this._data.token);
    const requestOptions: RequestOptionsArgs = {
      method: 'GET',
      headers: headerParams,
      search: queryParameters
    };
    return this._http
      .request(path, requestOptions)
      .map((response: Response) => {
        if (response.status === 204) {
          return undefined;
        } else if (response.status == 401) {
          this.deleteToken();
        } else {
          return response.json();
        }
      })
      .catch(this.handleError.bind(this));
  }

  getdefaultCompanyInfoForPrint(value: any): Observable<CompanyPrintInfo> {
    const path = `${apiUrl}` + `/estimates/${value}/defaultCompanyInfoForPrint`;
    // const path = `http://192.168.1.55:19401/ckj/v1` + `/estimates/${id}`;
    const queryParameters = new URLSearchParams();
    this.defaultHeaders.append(
      'Content-Type',
      'application/json;charset=utf-8'
    );
    const headerParams = this.defaultHeaders;
    headerParams.set('auth', this._data.token);
    const requestOptions: RequestOptionsArgs = {
      method: 'GET',
      headers: headerParams,
      search: queryParameters
    };
    return this._http
      .request(path, requestOptions)
      .map((response: Response) => {
        if (response.status === 204) {
          return undefined;
        } else if (response.status == 401) {
          this.deleteToken();
        } else {
          return response.json();
        }
      })
      .catch(this.handleError.bind(this));
  }

  getestimatesItem(estimatesItem: EstimatesItem): Observable<MitsumoriItems> {
    console.log('estimatesItem-> ', estimatesItem);

    let path = `${apiUrl}` + `/estimates/getMitsumoriItems?q=`;
    // path.endsWith('=') ? path += `` : path += `,`;

    if (estimatesItem.ModelCd) {
      path.endsWith('=') ? (path += ``) : (path += `,`);
      path += `modelCd%3D${estimatesItem.ModelCd}`;
    }

    if (estimatesItem.makerCd) {
      path.endsWith('=') ? (path += ``) : (path += `,`);
      path += `makerCd%3D${estimatesItem.makerCd}`;
    }

    if (estimatesItem.hanbaiDestinationFn) {
      path.endsWith('=') ? (path += ``) : (path += `,`);
      path += `hanbaiDestinationFn%3D${estimatesItem.hanbaiDestinationFn}`;
    }

    if (estimatesItem.hanbaiDestinationKanji) {
      path.endsWith('=') ? (path += ``) : (path += `,`);
      path += `hanbaiDestinationKanji%3D${
        estimatesItem.hanbaiDestinationKanji
        }`;
    }

    if (estimatesItem.hanbaiTantouCd) {
      path.endsWith('=') ? (path += ``) : (path += `,`);
      path += `hanbaiTantouCd%3D${estimatesItem.hanbaiTantouCd}`;
    }

    if (estimatesItem.hanbaikyotenCd) {
      path.endsWith('=') ? (path += ``) : (path += `,`);
      path += `hanbaiKyotenCd%3D${estimatesItem.hanbaikyotenCd}`;
    }

    if (estimatesItem.zaikoKanriCd) {
      path.endsWith('=') ? (path += ``) : (path += `,`);
      path += `zaikoKanriCd%3D${estimatesItem.zaikoKanriCd}`;
    }

    if (estimatesItem.sharyouKbn) {
      path.endsWith('=') ? (path += ``) : (path += `,`);
      path += `newcarFlg%3D${estimatesItem.sharyouKbn}`;
    }

    if (estimatesItem.mitsumoriYmd) {
      path.endsWith('=') ? (path += ``) : (path += `,`);
      path += `mitsumoriYmd%3D${encodeURIComponent(
        estimatesItem.mitsumoriYmd
      )}`;
    }

    if (estimatesItem.mitsumoriNo) {
      path.endsWith('=') ? (path += ``) : (path += `,`);
      path += `mitsumoriNo%3D${encodeURIComponent(estimatesItem.mitsumoriNo)}`;
    }

    if (estimatesItem.zaikoShatenCd) {
      path.endsWith('=') ? (path += ``) : (path += `,`);
      path += `zaikoShatenCd%3D${encodeURIComponent(
        estimatesItem.zaikoShatenCd
      )}`;
    }

    console.log(path);

    const queryParameters = new URLSearchParams();
    const headerParams = this.defaultHeaders;
    headerParams.set('auth', this._data.token);
    const requestOptions: RequestOptionsArgs = {
      method: 'GET',
      headers: headerParams,
      search: queryParameters
    };

    return this._http
      .request(path, requestOptions)
      .map((response: Response) => {
        if (response.status === 204) {
          return undefined;
        } else if (response.status == 401) {
          this.deleteToken();
        } else {
          return response.json();
        }
      })
      .catch(this.handleError.bind(this));
  }

  getSearchnameOrPlateNo(nameOrPlateNo: any): Observable<Customersearch> {
    const path =
      `${apiUrl}` +
      `/plan/searchCustomer?q=nameOrPlateNo%3D${encodeURIComponent(
        nameOrPlateNo
      )}` +
      `&size=20&page=1&sort=kokyaku_kanri_no`;
    const queryParameters = new URLSearchParams();
    const headerParams = this.defaultHeaders;
    headerParams.set('auth', this._data.token);
    const requestOptions: RequestOptionsArgs = {
      method: 'GET',
      headers: headerParams,
      search: queryParameters
    };
    return this._http
      .request(path, requestOptions)
      .map((response: Response) => {
        if (response.status === 204) {
          return undefined;
        } else if (response.status == 401) {
          this.deleteToken();
        } else {
          return response.json();
        }
      })
      .catch(this.handleError.bind(this));
  }

  getSearchCustomer(
    searchcustomer: SearchCustomer,
    sort?
  ): Observable<Customersearch> {
    let path = `${apiUrl}` + `/plan/searchCustomer?q=`;

    if (searchcustomer.customerNo) {
      path.endsWith('=') ? (path += ``) : (path += `,`);
      path += `customerNo%3D${encodeURIComponent(searchcustomer.customerNo)}`;
    }

    if (searchcustomer.shoudanKbn) {
      path.endsWith('=') ? (path += ``) : (path += `,`);
      path += `shoudanKbn%3D${searchcustomer.shoudanKbn}`;
    }

    if (searchcustomer.houjinKbn) {
      path.endsWith('=') ? (path += ``) : (path += `,`);
      path += `hojinKbn%3D${searchcustomer.houjinKbn}`;
    }

    if (searchcustomer.staffCd) {
      path.endsWith('=') ? (path += ``) : (path += `,`);
      path += `staffCd%3D${searchcustomer.staffCd}`;
    }

    if (searchcustomer.telNumber1) {
      path.endsWith('=') ? (path += ``) : (path += `,`);
      path += `telNumber1%3D${searchcustomer.telNumber1}`;
    }

    if (searchcustomer.telNumber2) {
      path.endsWith('=') ? (path += ``) : (path += `,`);
      path += `telNumber2%3D${searchcustomer.telNumber2}`;
    }

    if (searchcustomer.telNumber3) {
      path.endsWith('=') ? (path += ``) : (path += `,`);
      path += `telNumber3%3D${searchcustomer.telNumber3}`;
    }

    if (searchcustomer.mobileNumber1) {
      path.endsWith('=') ? (path += ``) : (path += `,`);
      path += `mobileNumber1%3D${searchcustomer.mobileNumber1}`;
    }

    if (searchcustomer.mobileNumber2) {
      path.endsWith('=') ? (path += ``) : (path += `,`);
      path += `mobileNumber2%3D${searchcustomer.mobileNumber2}`;
    }

    if (searchcustomer.mobileNumber3) {
      path.endsWith('=') ? (path += ``) : (path += `,`);
      path += `mobileNumber3%3D${searchcustomer.mobileNumber3}`;
    }

    if (searchcustomer.kojinNmKjLast) {
      path.endsWith('=') ? (path += ``) : (path += `,`);
      path += `kojinNmKjLast%3D${encodeURIComponent(
        searchcustomer.kojinNmKjLast
      )}`;
    }

    if (searchcustomer.kojinNmKjFirst) {
      path.endsWith('=') ? (path += ``) : (path += `,`);
      path += `kojinNmKjFirst%3D${encodeURIComponent(
        searchcustomer.kojinNmKjFirst
      )}`;
    }

    if (searchcustomer.mailMobile) {
      path.endsWith('=') ? (path += ``) : (path += `,`);
      path += `mailMobile%3D${searchcustomer.mailMobile}`;
    }

    if (searchcustomer.mailPc) {
      path.endsWith('=') ? (path += ``) : (path += `,`);
      path += `mailPc%3D${searchcustomer.mailPc}`;
    }

    if (searchcustomer.kyotenCd) {
      path.endsWith('=') ? (path += ``) : (path += `,`);
      path += `kyotenCd%3D${searchcustomer.kyotenCd}`;
    }

    if (searchcustomer.rank1CdStart) {
      path.endsWith('=') ? (path += ``) : (path += `,`);
      path += `rank1CdStart%3D${searchcustomer.rank1CdStart}`;
    }

    if (searchcustomer.rank1CdEnd) {
      path.endsWith('=') ? (path += ``) : (path += `,`);
      path += `rank1CdEnd%3D${searchcustomer.rank1CdEnd}`;
    }

    if (searchcustomer.rank2CdStart) {
      path.endsWith('=') ? (path += ``) : (path += `,`);
      path += `rank2CdStart%3D${searchcustomer.rank2CdStart}`;
    }

    if (searchcustomer.rank2CdEnd) {
      path.endsWith('=') ? (path += ``) : (path += `,`);
      path += `rank2CdEnd%3D${searchcustomer.rank2CdEnd}`;
    }

    if (searchcustomer.bunrui1CdStart) {
      path.endsWith('=') ? (path += ``) : (path += `,`);
      path += `bunrui1CdStart%3D${searchcustomer.bunrui1CdStart}`;
    }

    if (searchcustomer.bunrui1CdEnd) {
      path.endsWith('=') ? (path += ``) : (path += `,`);
      path += `bunrui1CdEnd%3D${searchcustomer.bunrui1CdEnd}`;
    }

    if (searchcustomer.bunrui2CdStart) {
      path.endsWith('=') ? (path += ``) : (path += `,`);
      path += `bunrui2CdStart%3D${searchcustomer.bunrui2CdStart}`;
    }

    if (searchcustomer.bunrui2CdEnd) {
      path.endsWith('=') ? (path += ``) : (path += `,`);
      path += `bunrui2CdEnd%3D${searchcustomer.bunrui2CdEnd}`;
    }

    if (searchcustomer.kojinNmFnFirst) {
      path.endsWith('=') ? (path += ``) : (path += `,`);
      path += `kojinNmFnFirst%3D${encodeURIComponent(
        searchcustomer.kojinNmFnFirst
      )}`;
    }

    if (searchcustomer.kojinNmFnLast) {
      path.endsWith('=') ? (path += ``) : (path += `,`);
      path += `kojinNmFnLast%3D${encodeURIComponent(
        searchcustomer.kojinNmFnLast
      )}`;
    }

    if (searchcustomer.nameOrPlateNo) {
      path.endsWith('=') ? (path += ``) : (path += `,`);
      path += `nameOrPlateNo%3D${encodeURIComponent(
        searchcustomer.nameOrPlateNo
      )}`;
    }

    if (searchcustomer.houjinNmKj) {
      path.endsWith('=') ? (path += ``) : (path += `,`);
      path += `houjinNmKj%3D${encodeURIComponent(searchcustomer.houjinNmKj)}`;
    }

    if (searchcustomer.houjinNmFn) {
      path.endsWith('=') ? (path += ``) : (path += `,`);
      path += `houjinNmFn%3D${encodeURIComponent(searchcustomer.houjinNmFn)}`;
    }

    if (sort) {
      !path.endsWith('=')
        ? (path += `&size=${sort.rowSelect}&page=${
          sort.page
          }&sort=-kokyaku_kanri_no`)
        : (path += ``);
    } else {
      !path.endsWith('=')
        ? (path += `&size=20&page=1&sort=-kokyaku_kanri_no`)
        : (path += ``);
    }

    console.log(path);

    const queryParameters = new URLSearchParams();
    const headerParams = this.defaultHeaders;
    headerParams.set('auth', this._data.token);
    const requestOptions: RequestOptionsArgs = {
      method: 'GET',
      headers: headerParams,
      search: queryParameters
    };
    return this._http
      .request(path, requestOptions)
      .map((response: Response) => {
        if (response.status === 204) {
          return undefined;
        } else if (response.status == 401) {
          this.deleteToken();
        } else {
          return response.json();
        }
      })
      .catch(this.handleError.bind(this));
  }

  getOrderItems(purchaseItem: PurchaseItem): Observable<OrderItems> {
    let path = `${apiUrl}` + `/orders/getOrderItems?q=`;

    if (purchaseItem.sharyouKbn) {
      path.endsWith('=') ? (path += ``) : (path += `,`);
      path += `newcarFlg%3D${purchaseItem.sharyouKbn}`;
    }

    if (purchaseItem.chumonNo) {
      path.endsWith('=') ? (path += ``) : (path += `,`);
      path += `chumonNo%3D${encodeURIComponent(purchaseItem.chumonNo)}`;
    }

    if (purchaseItem.hanbaiDestinationFn) {
      path.endsWith('=') ? (path += ``) : (path += `,`);
      path += `hanbaiDestinationFn%3D${purchaseItem.hanbaiDestinationFn}`;
    }

    if (purchaseItem.makerCd) {
      path.endsWith('=') ? (path += ``) : (path += `,`);
      path += `makerCd%3D${purchaseItem.makerCd}`;
    }

    if (purchaseItem.modelCd) {
      path.endsWith('=') ? (path += ``) : (path += `,`);
      path += `modelCd%3D${purchaseItem.modelCd}`;
    }

    if (purchaseItem.zaikoShatenCd) {
      path.endsWith('=') ? (path += ``) : (path += `,`);
      path += `zaikoShatenCd%3D${purchaseItem.zaikoShatenCd}`;
    }

    if (purchaseItem.zaikoKanriCd) {
      path.endsWith('=') ? (path += ``) : (path += `,`);
      path += `zaikoKanriCd%3D${purchaseItem.zaikoKanriCd}`;
    }

    if (purchaseItem.hanbaiKyotenCd) {
      path.endsWith('=') ? (path += ``) : (path += `,`);
      path += `hanbaiKyotenCd%3D${purchaseItem.hanbaiKyotenCd}`;
    }

    if (purchaseItem.hanbaiTantouCd) {
      path.endsWith('=') ? (path += ``) : (path += `,`);
      path += `hanbaiTantouCd%3D${purchaseItem.hanbaiTantouCd}`;
    }

    if (purchaseItem.hanbaiDestinationKanji) {
      path.endsWith('=') ? (path += ``) : (path += `,`);
      path += `hanbaiDestinationKanji%3D${purchaseItem.hanbaiDestinationKanji}`;
    }

    if (purchaseItem.kkkbn) {
      path.endsWith('=') ? (path += ``) : (path += `,`);
      path += `kk_kbn%3D${purchaseItem.kkkbn}`;
    }

    if (purchaseItem.chumonYmd) {
      path.endsWith('=') ? (path += ``) : (path += `,`);
      path += `chumonYmd%3D${purchaseItem.chumonYmd}`;
    }

    console.log(path);

    // const path = `${ apiUrl } ` + ` / orders / getOrderItems`;
    const queryParameters = new URLSearchParams();
    const headerParams = this.defaultHeaders;
    headerParams.set('auth', this._data.token);
    const requestOptions: RequestOptionsArgs = {
      method: 'GET',
      headers: headerParams,
      search: queryParameters
    };
    return this._http
      .request(path, requestOptions)
      .map((response: Response) => {
        if (response.status === 204) {
          return undefined;
        } else if (response.status == 401) {
          this.deleteToken();
        } else {
          return response.json();
        }
      })
      .catch(this.handleError.bind(this));
  }

  getrankMasterList(value: string): Observable<any> {
    const path = `${apiUrl}` + `/customers/rankMasterList?q=kbn=${value}`;
    const queryParameters = new URLSearchParams();
    const headerParams = this.defaultHeaders;
    headerParams.set('auth', this._data.token);
    const requestOptions: RequestOptionsArgs = {
      method: 'GET',
      headers: headerParams,
      search: queryParameters
    };
    return this._http
      .request(path, requestOptions)
      .map((response: Response) => {
        if (response.status === 204) {
          return undefined;
        } else if (response.status == 401) {
          this.deleteToken();
        } else {
          return response.json();
        }
      })
      .catch(this.handleError.bind(this));
  }

  getunixTime(date: any) {
    const myDate: number = moment(date).unix();
    return myDate;
  }

  getshutokuzei(shutokuzei: any, hanbaikyotencd: string): Observable<any> {
    if (!shutokuzei && isNaN(shutokuzei)) {
      shutokuzei = 0;
    }
    const path =
      `${apiUrl}` +
      `/plan/shutokuzei/marume?q=shutokuzei%3D${shutokuzei},hanbaiKyotenCd%3D${hanbaikyotencd}`;
    const queryParameters = new URLSearchParams();
    const headerParams = this.defaultHeaders;
    headerParams.set('auth', this._data.token);
    const requestOptions: RequestOptionsArgs = {
      method: 'GET',
      headers: headerParams,
      search: queryParameters
    };
    return this._http
      .request(path, requestOptions)
      .map((response: Response) => {
        if (response.status === 204) {
          return undefined;
        } else if (response.status == 401) {
          this.deleteToken();
        } else {
          return response.json();
        }
      })
      .catch(this.handleError.bind(this));
  }

  loginDialogModel(value?: any): Observable<any> {
    const path = `${apiUrl}` + `/staff/auth`;
    const queryParameters = new URLSearchParams();
    const headerParams = this.defaultHeaders;
    headerParams.set('auth', this._data.token);
    headerParams.set('Content-Type', 'application/json');
    const bodys = value;
    const requestOptions: RequestOptionsArgs = {
      headers: headerParams,
      search: queryParameters
    };

    if (value) {
      return this._http
        .post(path, bodys, requestOptions)
        .map((response: Response) => {
          if (response.status === 204) {
            return undefined;
          } else {
            return response.json();
          }
        })
        .catch(this.handleError.bind(this));
    } else {
      return this._http
        .delete(path, requestOptions)
        .map((response: Response) => {
          if (response.status === 204) {
            return undefined;
          } else {
            return true;
          }
        })
        .catch(e => {
          if (e.status === 409) {
            return Observable.throw('Unauthorized');
          } else {
            this.handleError.bind(this);
          }
        });
      // .catch(this.handleError.bind(this));
    }
  }

  getAuthDetail() {
    const path = `${apiUrl}` + `/staff/auth`;
    const queryParameters = new URLSearchParams();
    const headerParams = this.defaultHeaders;
    headerParams.set('auth', this._data.token);
    headerParams.set('Content-Type', 'application/json');
    const requestOptions: RequestOptionsArgs = {
      headers: headerParams,
      search: queryParameters
    };
    return this._http
      .get(path, requestOptions)
      .map((response: Response) => {
        if (response.status === 204) {
          return undefined;
        } else {
          return response.json();
        }
      })
      .catch(e => {
        if (e.status === 401) {
          return Observable.throw('Unauthorized');
        } else if (e.status === 404) {
          return Observable.throw(e.status);
        } else if (e.status === 400) {
          return Observable.throw(e.status);
        }
      });
  }

  getzaikoShaten(): Observable<any> {
    const path = `${apiUrl}` + `/plan/zaikoShatenList`;
    const queryParameters = new URLSearchParams();
    const headerParams = this.defaultHeaders;
    headerParams.set('auth', this._data.token);
    const requestOptions: RequestOptionsArgs = {
      method: 'GET',
      headers: headerParams,
      search: queryParameters
    };
    return this._http
      .request(path, requestOptions)
      .map((response: Response) => {
        if (response.status === 204) {
          return undefined;
        } else if (response.status == 401) {
          this.deleteToken();
        } else {
          return response.json();
        }
      })
      .catch(this.handleError.bind(this));
  }

  getZaikoItems(zaiko: Zaiko): Observable<ZaikoItems> {
    let path = '';

    let shatenCdString = '';
    let keitooColorString = '';
    let makerCdString = '';
    let modelCdString = '';
    let sharyouKbnstring = '';
    let kanriNostring = '';
    let nenshikiFromstring = '';
    let nenshikiTostring = '';
    let hanbaiPriceFromstring = '';
    let hanbaiPriceTostring = '';

    let nyukoBunruistring = '';
    let katashikistring = '';
    let shiireKyotenFromstring = '';
    let shiireKyotenTostring = '';
    let zaikoKyotenstring = '';
    let shadaiNostring = '';
    let plateKbnstring = '';
    let plateAreastring = '';
    let plateModestring = '';
    let plateKanastring = '';
    let plateBangoustring = '';
    let equipmentstring = '';
    let urlPaths = [];

    if (zaiko.shatenCd && zaiko.shatenCd != '') {
      shatenCdString = 'shatenCd%3D' + zaiko.shatenCd;
    } else {
      shatenCdString = '';
    }
    shatenCdString = shatenCdString.replace('', '');
    urlPaths.push(shatenCdString);

    if (zaiko.keitooColor) {
      keitooColorString = 'keitooColor%3D' + zaiko.keitooColor;
    } else {
      keitooColorString = '';
    }
    keitooColorString = keitooColorString.replace('', '');
    urlPaths.push(keitooColorString);

    if (zaiko.makerCd && zaiko.makerCd != '') {
      makerCdString = 'makerCd%3D' + zaiko.makerCd;
    } else {
      makerCdString = '';
    }
    makerCdString = makerCdString.replace('', '');
    urlPaths.push(makerCdString);

    if (zaiko.modelCd && zaiko.modelCd != '') {
      modelCdString = 'modelCd%3D' + zaiko.modelCd;
    } else {
      modelCdString = '';
    }
    modelCdString = modelCdString.replace('', '');
    urlPaths.push(modelCdString);

    if (zaiko.sharyouKbn) {
      sharyouKbnstring = 'sharyouKbn%3D' + zaiko.sharyouKbn;
    } else {
      sharyouKbnstring = '';
    }
    sharyouKbnstring = sharyouKbnstring.replace('', '');
    urlPaths.push(sharyouKbnstring);

    if (zaiko.kanriNo && zaiko.kanriNo != '') {
      kanriNostring = 'kanriNo%3D' + zaiko.kanriNo;
    } else {
      kanriNostring = '';
    }
    kanriNostring = kanriNostring.replace('', '');
    urlPaths.push(kanriNostring);

    if (zaiko.nenshikiFrom && zaiko.nenshikiFrom != '') {
      nenshikiFromstring = 'nenshikiFrom%3D' + zaiko.nenshikiFrom;
    } else {
      nenshikiFromstring = '';
    }
    nenshikiFromstring = nenshikiFromstring.replace('', '');
    urlPaths.push(nenshikiFromstring);

    if (zaiko.nenshikiTo && zaiko.nenshikiTo != '') {
      nenshikiTostring = 'nenshikiTo%3D' + zaiko.nenshikiTo;
    } else {
      nenshikiTostring = '';
    }
    nenshikiTostring = nenshikiTostring.replace('', '');
    urlPaths.push(nenshikiTostring);

    if (zaiko.hanbaiPriceFrom) {
      hanbaiPriceFromstring = 'hanbaiPriceFrom%3D' + zaiko.hanbaiPriceFrom;
    } else {
      hanbaiPriceFromstring = '';
    }
    hanbaiPriceFromstring = hanbaiPriceFromstring.replace('', '');
    urlPaths.push(hanbaiPriceFromstring);

    if (zaiko.hanbaiPriceTo) {
      hanbaiPriceTostring = 'hanbaiPriceTo%3D' + zaiko.hanbaiPriceTo;
    } else {
      hanbaiPriceTostring = '';
    }
    hanbaiPriceTostring = hanbaiPriceTostring.replace('', '');
    urlPaths.push(hanbaiPriceTostring);

    if (zaiko.nyukoBunrui) {
      nyukoBunruistring = 'nyukoBunrui%3D' + zaiko.nyukoBunrui;
    } else {
      nyukoBunruistring = '';
    }
    nyukoBunruistring = nyukoBunruistring.replace('', '');
    urlPaths.push(nyukoBunruistring);

    if (zaiko.katashiki && zaiko.katashiki != '') {
      katashikistring = 'katashiki%3D' + zaiko.katashiki;
    } else {
      katashikistring = '';
    }
    katashikistring = katashikistring.replace('', '');
    urlPaths.push(katashikistring);

    if (zaiko.shiireKyotenFrom && zaiko.shiireKyotenFrom != '') {
      shiireKyotenFromstring = 'shiireKyotenFrom%3D' + zaiko.shiireKyotenFrom;
    } else {
      shiireKyotenFromstring = '';
    }
    shiireKyotenFromstring = shiireKyotenFromstring.replace('', '');
    urlPaths.push(shiireKyotenFromstring);

    if (zaiko.shiireKyotenTo && zaiko.shiireKyotenTo != '') {
      shiireKyotenTostring = 'shiireKyotenTo%3D' + zaiko.shiireKyotenTo;
    } else {
      shiireKyotenTostring = '';
    }
    shiireKyotenTostring = shiireKyotenTostring.replace('', '');
    urlPaths.push(shiireKyotenTostring);

    if (zaiko.zaikoKyoten && zaiko.zaikoKyoten != '') {
      zaikoKyotenstring = 'zaikoKyoten%3D' + zaiko.zaikoKyoten;
    } else {
      zaikoKyotenstring = '';
    }
    zaikoKyotenstring = zaikoKyotenstring.replace('', '');
    urlPaths.push(zaikoKyotenstring);

    if (zaiko.shadaiNo && zaiko.shadaiNo != '') {
      shadaiNostring = 'shadaiNo%3D' + zaiko.shadaiNo;
    } else {
      shadaiNostring = '';
    }
    shadaiNostring = shadaiNostring.replace('', '');
    urlPaths.push(shadaiNostring);

    if (zaiko.plateKbn) {
      plateKbnstring = 'plateKbn%3D' + zaiko.plateKbn;
    } else {
      plateKbnstring = '';
    }
    plateKbnstring = plateKbnstring.replace('', '');
    urlPaths.push(plateKbnstring);

    if (zaiko.plateArea && zaiko.plateArea != '') {
      plateAreastring = 'plateArea%3D' + zaiko.plateArea;
    } else {
      plateAreastring = '';
    }
    plateAreastring = plateAreastring.replace('', '');
    urlPaths.push(plateAreastring);

    if (zaiko.plateModel && zaiko.plateModel != '') {
      plateModestring = 'plateModel%3D' + zaiko.plateModel;
    } else {
      plateModestring = '';
    }
    plateModestring = plateModestring.replace('', '');
    urlPaths.push(plateModestring);

    if (zaiko.plateKana && zaiko.plateKana != '') {
      plateKanastring = 'plateKana%3D' + zaiko.plateKana;
    } else {
      plateKanastring = '';
    }
    plateKanastring = plateKanastring.replace('', '');
    urlPaths.push(plateKanastring);

    if (zaiko.plateBangou && zaiko.plateBangou != '') {
      plateBangoustring = 'plateBangou%3D' + zaiko.plateBangou;
    } else {
      plateBangoustring = '';
    }
    plateBangoustring = plateBangoustring.replace('', '');
    urlPaths.push(plateBangoustring);

    if (zaiko.equipment && zaiko.equipment.length != 0) {
      equipmentstring = 'equipment%3D' + zaiko.equipment;
    } else {
      equipmentstring = '';
    }
    equipmentstring = equipmentstring.replace('', '');
    urlPaths.push(equipmentstring);

    // zaikoKyotenstring

    path = `${apiUrl}` + `/plan/getZaikoItems?size=100&q=`;

    urlPaths = urlPaths.filter(val => val != '');

    if (urlPaths.length != 0) {
      urlPaths.forEach((e, i) => {
        if (e != null || e !== undefined) {
          path += e + ',';
        }
      });
    }
    // console.log(urlPaths);
    // console.log(path);

    // path =
    //   `${apiUrl}` +
    //   `/plan/getZaikoItems?q=${shatenCdString}${keitooColorString}${makerCdString}${modelCdString}&size=20`;

    const queryParameters = new URLSearchParams();
    const headerParams = this.defaultHeaders;
    headerParams.set('auth', this._data.token);
    const requestOptions: RequestOptionsArgs = {
      method: 'GET',
      headers: headerParams,
      search: queryParameters
    };
    return this._http
      .request(path, requestOptions)
      .map((response: Response) => {
        if (response.status === 204) {
          return undefined;
        } else if (response.status == 401) {
          this.deleteToken();
        } else {
          return response.json();
        }
      })
      .catch(this.handleError.bind(this));
  }

  getzaikoShiireMemoList(zaikoCd: string): Observable<any> {
    const path =
      `${apiUrl}` + `/plan/zaikoShiireMemoList?q=zaikoCd%3D${zaikoCd}`;
    const queryParameters = new URLSearchParams();
    const headerParams = this.defaultHeaders;
    headerParams.set('auth', this._data.token);
    const requestOptions: RequestOptionsArgs = {
      method: 'GET',
      headers: headerParams,
      search: queryParameters
    };
    return this._http
      .request(path, requestOptions)
      .map((response: Response) => {
        if (response.status === 204) {
          return undefined;
        } else if (response.status == 401) {
          this.deleteToken();
        } else {
          return response.json();
        }
      })
      .catch(this.handleError.bind(this));
  }

  getQuestionnaires(): Observable<Questionnaire[]> {
    const path = `${apiUrl}` + `/master/questionnaire/`;
    const queryParameters = new URLSearchParams();
    const headerParams = this.defaultHeaders;

    headerParams.set('auth', this._data.token);
    const requestOptions: RequestOptionsArgs = {
      method: 'GET',
      headers: headerParams
      // search: queryParameters
    };

    return this._http
      .request(path, requestOptions)
      .map((response: Response) => {
        if (response.status === 204) {
          return undefined;
        } else if (response.status == 401) {
          this.deleteToken();
        } else {
          return response.json();
        }
      })
      .catch(this.handleError.bind(this));
  }

  getDialogApiOrder(oradersNo): Observable<SavedialogOrder> {
    let path = '';
    if (oradersNo != null) {
      path = `${apiUrl}/orders/saveDialogState?q=chumonNo%3D${oradersNo}`;
    } else {
      path = `${apiUrl}/orders/saveDialogState`;
    }
    const queryParameters = new URLSearchParams();
    const headerParams = this.defaultHeaders;
    headerParams.set('auth', this._data.token);
    headerParams.set('Content-Type', 'application/json;charset=utf-8');
    headerParams.set('Accept', 'application/json');
    const requestOptions: RequestOptionsArgs = {
      method: 'GET',
      headers: headerParams,
      search: queryParameters
    };
    return this._http
      .request(path, requestOptions)
      .map((response: Response) => {
        if (response.status === 204) {
          return undefined;
        } else {
          return response.json();
        }
      })
      .catch(this.handleError.bind(this));
  }

  // getDialogApiOrder(): Observable<SavedialogOrder> {
  //   const path = `${apiUrl}/orders/saveDialogState`;
  //   const queryParameters = new URLSearchParams();
  //   const headerParams = this.defaultHeaders;
  //   headerParams.set('auth', this._data.token);
  //   headerParams.set('Content-Type', 'application/json;charset=utf-8');
  //   headerParams.set('Accept', 'application/json');
  //   const requestOptions: RequestOptionsArgs = {
  //     method: 'GET',
  //     headers: headerParams,
  //     search: queryParameters
  //   };

  //   return this._http.request(path, requestOptions)
  //     .map((response: Response) => {
  //       if (response.status === 204) {
  //         return undefined;
  //       } else if (response.status == 401) {
  //         this.deleteToken();
  //       } else {
  //         return response.json();
  //       }
  //     }).catch(this.handleError.bind(this));
  // }

  getDialogApiestimate(mitsumoriNo?): Observable<Savedialogstate> {
    let path = '';
    if (mitsumoriNo != null) {
      path = `${apiUrl}/estimates/saveDialogState?q=mitsumoriNo%3D${mitsumoriNo}`;
    } else {
      path = `${apiUrl}/estimates/saveDialogState`;
    }

    const queryParameters = new URLSearchParams();
    const headerParams = this.defaultHeaders;
    headerParams.set('auth', this._data.token);
    headerParams.set('Content-Type', 'application/json;charset=utf-8');
    headerParams.set('Accept', 'application/json');
    const requestOptions: RequestOptionsArgs = {
      method: 'GET',
      headers: headerParams,
      search: queryParameters
    };

    return this._http
      .request(path, requestOptions)
      .map((response: Response) => {
        if (response.status === 204) {
          return undefined;
        } else if (response.status == 401) {
          this.deleteToken();
        } else {
          return response.json();
        }
      })
      .catch(this.handleError.bind(this));
  }

  setEnvironmentSetting(value: EnvironmentSetting) {
    this.dataenviroment = value;
    this.prefCd = value.prefCd;
  }

  getEnvironmentSetting() {
    return this.dataenviroment;
  }

  // http://104.198.91.7:12001/ckj/v1/plan/getZaikoItems?q=sharyouKbn=2,shatenCd=0001&size=10

  deleteToken() {
    const token = this._data.token;
    const headers = PlanMainService.headers;
    headers.set('auth', token);
    console.log('Check 401', headers);
    if (this._data.token !== null) {
      this.clearDataAndNavigateToLogin();
      return this._http
        .delete(`${apiUrl}/auth/token`, { headers: PlanMainService.headers })
        .subscribe(() => { });
    }
  }

  private handleError(error: Response | any) {
    // In a real world app, we might use a remote logging infrastructure
    let errMsg: string;
    if (error instanceof Response) {
      const body = error.json() || '';
      // const err = body.error || JSON.stringify(body);
      console.log(JSON.parse(JSON.stringify(body)), 'error.message');
      errMsg = body; // `${error.status} - ${error.statusText || ''} ${err}`;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }

    // console.error(error.status);
    if (error.status === 401) {
      this.deleteToken();
    } else {
      return Observable.throw(errMsg);
    }
  }

  private handleErrorweb(error: Response | any) {
    // In a real world app, we might use a remote logging infrastructure
    let errMsg: string;
    let bodystring: string;
    if (error instanceof Response) {
      const body = error.json() || '';
      const err = body.error || JSON.stringify(body);
      bodystring = JSON.stringify(body.__body);
      errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }
    console.log(error, 'error.message');
    // console.error(error.status);
    if (error.status === 401) {
      this.deleteToken();
    } else {
      return Observable.throw(error._body);
    }
  }

  clearDataAndNavigateToLogin() {
    this._data.clearData();
    // location.reload();
    this.router.navigate(['/login']);
  }

  checkJapan(word: any): boolean {
    const jp = /[\u3000-\u303F]|[\u3040-\u309F]|[\u30A0-\u30FF]|[\uFF00-\uFFEF]|[\u4E00-\u9FAF]|[\u2605-\u2606]|[\u2190-\u2195]|[０-９]\u203B/g;
    return jp.test(word);
  }

  onremoveServiceplan() {
    this.addRecycledata(null);
    this.addTaxValue(null);
    this.setCustomer(null);
    this.addtradeinData(null);
    this.adddopdealarvalue(null);
    // this.setDatauseCar(null);
    this.setDataHop(null);
    this.setdateMop(null);
    this.settotal(null);
    this.shohiyouHikazeiSave.next(null);
    this.shohiyouKazeiSave.next(null);
    this.bahaviorNextnull();
    // this._pl.settaxService(this.taxobj);
  }

  bahaviorNextnull() {
    this.chosenDataRecycling.next(null);
    this.chosenDataTrade.next('');
    this.chosenClearState.next('');
    // this.totlerecycling.next('');
    this.setHunbaiOptionSelected.next(null);
    this.setPlanHunbai.next('');
    this.setPlanDealer.next('');
    // this.usecarservice.next(null);
    this.tradeinvalue.next(null);
    this.taxvaluedata.next(null);
    this.recycledata.next(null);
    this.customersData.next(null);
    this.stockdetail.next(null);
    this.tadeincar.next(null);
    this.tadeincar2.next(null);
    this.valueselect.next(null);
    this.valueselect2.next(null);
    this.valueRecycletadein.next(null);
    this.valueRecycletadein2.next(null);
    this.dealerOption.next(null);
    this.dopdealarvalue.next(null);
    this.doploanflags.next([]);
    this.dopSave.next([]);
    this.doploanNotSave.next(null);
    this.consumptiontax.next(80);
    this.savadataPlan.next(null);
    this.hanbaitenOptions.next(null);
    this.datahopvalue.next(null);
    this.datamop.next(null);
    this.listdatacustomers.next(null);
    this.datapurchaseSearch.next(null);
    this.savedatachumon.next(null);
    this.addTotal.next(null);
    this.shohiyouHikazeiSave.next(null);
    this.shohiyouKazeiSave.next(null);
    this.valuesumitemshutokuzei.next(0);
    this.valueSumshutokuzeiMaker.next(0);
    this.valueSumshutokuzeiMaker2.next(0);
    this.valueSumshutokuzeiMaker3.next(0);
    this.valueSumshutokuzeiHop.next(0);
    this.valueSumshutokuzeiHop2.next(0);
    this.valueSumshutokuzeiHop3.next(0);
    this.addmakerOption.next(null);
    this.basicserviceobj.next(null);
    this.basicOrders.next(null);
    this.taxValueselect.next(null);
    this.statusGrade.next(1);
    this.resetvalue.next(null);
    this.staffDialog.next(null);
    this.setMakerClound([]);
    this.setMakerCloundKbn([]);
    this.defaultPaymentSetting.next(null);
    // this.staffDialogCallback.next(null);
  }

  getJuuryoKbn(weightTaxCd: string, weightTaxTaxationKbn: string) {
    if (weightTaxCd) {
      let kbn = null;
      if (weightTaxCd.length === 2) {
        kbn = '4'; // 通常
      } else {
        const code = weightTaxCd.substring(3, 5);
        const arr25 = ['25', '2A', '2B', '2E', '2F', '2G', 'K2', 'KA'];
        const arr50 = ['50', '5A', '5C', '5D', 'K5'];
        const arr75 = ['75', '7A', 'K7'];
        const arrNormal = ['EF', 'EG', 'EH', 'EJ', 'KF', 'KG', 'KH', 'KJ']; // 通常
        const arr13 = ['00', '0A', '1A', 'KB', 'KC', 'KD', 'KE']; // 13年未満
        if (code === 'FF') {// 免税
          kbn = '1';
        } else if (arr25.indexOf(code) > -1) { // 25%
          kbn = '16';
        } else if (arr50.indexOf(code) > -1) { // 50%
          kbn = '15';
        } else if (arr75.indexOf(code) > -1) { // 75%
          kbn = '17';
        } else if (arr13.indexOf(code) > -1) { // 13年未満
          kbn = '0';
        } else if (arrNormal.indexOf(code) > -1) { // 通常
          kbn = '4';
        }
      }
      if (kbn != null) {
        return kbn;
      } else {
        return weightTaxTaxationKbn;
      }
    }
    return weightTaxTaxationKbn;
  }

  updateCustomer(customerNo: string, customerCarNo: string): Observable<any> {
    const path =
      `${apiUrl}` +
      `/customer/${customerNo}` +
      `/car/${customerCarNo}` +
      `/markAsSaled`;
    const queryParameters = new URLSearchParams();
    const headerParams = new Headers({ 'Content-Type': 'application/json' });
    headerParams.set('auth', this._data.token);
    const requestOptions: RequestOptionsArgs = {
      method: 'PUT',
      headers: headerParams
    };
    return this._http
      .request(path, requestOptions)
      .map((response: Response) => {
        if (response.status == 401) {
          this.deleteToken();
        } else {
          return response.status;
        }
      })
      .catch(this.handleError.bind(this));
  }

  cancelOrder(chumonCd) {
    const path = `${apiUrl}/orders/${chumonCd}` + `/cancel/`;

    const queryParameters = new URLSearchParams();
    const headerParams = new Headers({ 'Content-Type': 'application/json' });
    headerParams.set('auth', this._data.token);
    const requestOptions: RequestOptionsArgs = {
      method: 'PUT',
      headers: headerParams
    };
    return this._http
      .request(path, requestOptions)
      .map((response: Response) => {
        if (response.status == 401) {
          this.deleteToken();
        } else {
          return response.status;
        }
      })
      .catch(this.handleErrorweb.bind(this));
  }

  // /plan/getWebCreditData

  getWebCreditData(
    mitsumoriCd?,
    chumonCd?,
    loanPlanNo?
  ): Observable<WebCreditData> {
    let path = '';
    if (mitsumoriCd) {
      path =
        `${apiUrl}` +
        `/plan/getWebCreditData?q=mitsumoriCd%3D${mitsumoriCd},loanPlanNo%3D${loanPlanNo}`;
    } else {
      path =
        `${apiUrl}` +
        `/plan/getWebCreditData?q=chumonCd%3D${chumonCd},loanPlanNo%3D${loanPlanNo}`;
    }
    const queryParameters = new URLSearchParams();
    const headerParams = this.defaultHeaders;

    headerParams.set('auth', this._data.token);
    const requestOptions: RequestOptionsArgs = {
      method: 'GET',
      headers: headerParams
      // search: queryParameters
    };

    return this._http
      .request(path, requestOptions)
      .map((response: Response) => {
        if (response.status === 204) {
          return undefined;
        } else if (response.status == 401) {
          this.deleteToken();
        } else {
          return response.json();
        }
      })
      .catch(this.handleErrorweb.bind(this));
  }

  setResponseStatus(res) {
    this.ResponseStatus = res;
  }

  private httpGet(url: string) {
    const headers = PlanService.headers;
    headers.set('auth', this._data.token);
    return this._http
      .get(url, { headers: headers })
      .map(response => {
        // if (response.status === 401) {
        //   console.log('response.status');
        //   console.log(response.status);
        //   this.clearDataAndNavigateToLogin();
        // } else {
        if (response.status !== 200) {
          this.setResponseStatus(response.status);
        } else {
          this.setResponseStatus(0);
        }
        return response.json();
        // }
      })
      .catch(this.handleError.bind(this));
  }

  getleaseCooperationData(mitsumoriNo: string): Observable<any> {
    const path1 = this.planType.chumon ? 'orders' : 'estimates';
    const path = `${apiUrl}` + `/${path1}/${mitsumoriNo}/leaseCooperationData`;

    return this.httpGet(path);
  }

  setOnSumMakerOption(makerObj) {
    this.makerOptionSum = makerObj;
  }
  getOnSumMakerOption() {
    const valMaker = { ...this.makerOptionSum };
    return valMaker;
  }

  passValidDate(date) {
    return moment(date, 'YYYY/MM/DD', true).isValid();
  }

  getCarImage(mitsumoriNo) {
    const path = `${apiUrl}/estimates/${mitsumoriNo}/carImagesForPrint`;
    // const path = `${apiUrl}/newcar/detail?q=prefCd=6,makerCd=00100,modelCd=04800,kaiseiYm=201710,gradeCd=00001`;
    const queryParameters = new URLSearchParams();
    const headerParams = new Headers({ 'Content-Type': 'application/json' });
    headerParams.set('auth', this._data.token);
    const requestOptions: RequestOptionsArgs = {
      method: 'GET',
      headers: headerParams
    };
    // console.log(' getCarImage', path);
    return this._http
      .get(path, { headers: headerParams })
      .map((response: Response) => {
        if (response.status == 401) {
          this.deleteToken();
        } else {
          return response.json();
        }
      })
      .catch(this.handleError.bind(this));
  }

  getCarImage2(orderNo) {
    const path = `${apiUrl}/orders/${orderNo}/carImagesForPrint`;
    // const path = `${apiUrl}/newcar/detail?q=prefCd=6,makerCd=00100,modelCd=04800,kaiseiYm=201710,gradeCd=00001`;
    const queryParameters = new URLSearchParams();
    const headerParams = new Headers({ 'Content-Type': 'application/json' });
    headerParams.set('auth', this._data.token);
    const requestOptions: RequestOptionsArgs = {
      method: 'GET',
      headers: headerParams
    };
    // console.log(' getCarImage', path);
    return this._http
      .get(path, { headers: headerParams })
      .map((response: Response) => {
        if (response.status == 401) {
          this.deleteToken();
        } else {
          return response.json();
        }
      })
      .catch(this.handleError.bind(this));
  }

  ongetCompanyValue(creditCompany: number) {
    return creditCompany == 0 ? '' : creditCompanyMap.get(creditCompany);
  }

  convertLoanDetailToLoan(): Load {
    return {
      selectedPlanNum: this.planservice.isPlanOneActivated.getValue() ? 1 : 2,
      useLoan: 1,
      plan1: {
        isManualInput: '1',
        shinpanKbn: this.planservice.loanCreditCompanyOne.getValue(),
        loanPlanKbn: this.planservice.loanchosenLoanPlanOne.getValue(),
        shinpanKyotenCd: this._data.kyotenCd,
        paymentCnt: this.planservice.loanOnePaymentCount.getValue(),
        paymentStartYm: this.planservice.loanOneFirstPaymentYM.getValue(),
        kappuTesuuryou: this.planservice.loanOneKappuTesuuRyou.getValue(),
        bonusMonth1: this.planservice.loanOneBonusMonthOne.getValue(),
        bonusMonth2: this.planservice.loanOneBonusMonthTwo.getValue(),
        bonusCnt: this.planservice.loanOneBonusCount.getValue(),
        bonusKingaku: this.planservice.loanOneBonus.getValue(),
        shinpanNm: this.planservice.loanPlanOneName.getValue(),
        firstPayment: this.planservice.loanOneFirstPayment.getValue(),
        shinpanRenban: this.planservice.loanOneShinpanRenban.getValue(),
        monthlyPayment: this.planservice.loanOneMonthlyPayment.getValue(),
        atamakin: this.planservice.loanOneAtamakin.getValue(),
        shinpanCd: this.planservice.loanOneShinpanCode.getValue(),
        sueokiKingaku: this.planservice.loanOneSueokiPrice.getValue(),
        bonusStartYm: this.planservice.loanOneFirstBonusPaymentYM.getValue(),
        isSueoki: this.planservice.isPlanOneActivated.getValue()
          ? this.planservice.loanOneIsSueoki.getValue()
          : null,
        sueokiRitsu: this.planservice.loanOneSueokiRitsu.getValue()
      },
      plan2: {
        isManualInput: '1',
        shinpanKbn: this.planservice.loanCreditCompanyTwo.getValue(),
        loanPlanKbn: this.planservice.loanchosenLoanPlanTwo.getValue(),
        shinpanKyotenCd: this._data.kyotenCd,
        paymentCnt: this.planservice.loanTwoPaymentCount.getValue(),
        paymentStartYm: this.planservice.loanTwoFirstPaymentYM.getValue(),
        kappuTesuuryou: this.planservice.loanTwoKappuTesuuRyou.getValue(),
        bonusMonth1: this.planservice.loanTwoBonusMonthOne.getValue(),
        bonusMonth2: this.planservice.loanTwoBonusMonthTwo.getValue(),
        bonusCnt: this.planservice.loanTwoBonusCount.getValue(),
        bonusKingaku: this.planservice.loanTwoBonus.getValue(),
        shinpanNm: this.planservice.loanPlanTwoName.getValue(),
        firstPayment: this.planservice.loanTwoFirstPayment.getValue(),
        shinpanRenban: this.planservice.loanTwoShinpanRenban.getValue(),
        monthlyPayment: this.planservice.loanTwoMonthlyPayment.getValue(),
        atamakin: this.planservice.loanTwoAtamakin.getValue(),
        shinpanCd: this.planservice.loanTwoShinpanCode.getValue(),
        sueokiKingaku: this.planservice.loanTwoSueokiPrice.getValue(),
        bonusStartYm: this.planservice.loanTwoFirstBonusPaymentYM.getValue(),
        isSueoki: this.planservice.isPlanTwoActivated.getValue()
          ? this.planservice.loanTwoIsSueoki.getValue()
          : null,
        sueokiRitsu: this.planservice.loanTwoSueokiRitsu.getValue()
      }
    };
  }

  convertMiles_Km(value, soukouUnitKbn) {
    const pathconvert =
      soukouUnitKbn === '1' ? 'convertMilesToKm' : 'convertKmToMiles';
    const path = `${apiUrlcommon}/car/soukou/${pathconvert}?q=value=${value}`;
    const headerParams = new Headers({ 'Content-Type': 'application/json' });
    headerParams.set('auth', this._data.token);
    const requestOptions: RequestOptionsArgs = {
      method: 'GET',
      headers: headerParams
    };
    return this._http
      .get(path, { headers: headerParams })
      .map((response: Response) => {
        if (response.status == 401) {
          this.deleteToken();
        } else {
          return response.json();
        }
      })
      .catch(this.handleError.bind(this));
  }

  downloadManual(fileName: string) {
    const headers = new Headers({ 'Content-Type': 'application/pdf' });
    return this._http
      .get(`/assets/manual/${fileName}.pdf`, {
        headers: headers,
        responseType: ResponseContentType.Blob
      })
      .map(response => response.blob())
      .catch(this.handleError.bind(this));
  }

  resetShitadori() {
    this.tradeinvalue.next(null);
    this.setDatatadeincar(null);
    this.setDatatadeincar2(null);
    this.addvalueRecycletadein(null);
    this.addvalueRecycletadein2(null);
  }

  // getDefaultCustomer() {
  //   let customerobj = <Customer>{};
  //   customerobj.addressPrefDispKbn = '1';
  //   customerobj.keitaiMailEnabled = '0';
  //   customerobj.pcMailEnabled = '0';
  //   customerobj.isHoujin = '0';
  //   customerobj.kojinNmKjMei = '';
  //   customerobj.kojinNmKjSei = '';
  //   customerobj.kojinNmKnMei = '';
  //   customerobj.kojinNmKnSei = '';
  //   return customerobj;
  // }

  isCustomerDataComplete(data: Customer) {
    let res = false;
    if (
      ((data.isHoujin === '1' && data.houjinNmKj && data.houjinNmKn) ||
        (data.isHoujin === '0' &&
          data.kojinNmKjMei &&
          data.kojinNmKjSei &&
          data.kojinNmKnMei &&
          data.kojinNmKnSei)) &&
      (data.address1 && data.addressPrefCd && data.zipNo1 && data.zipNo2)
    ) {
      res = true;
    }
    return res;
  }

  isNoCustomerDataRequired(data: Customer) {
    let res = false;
    if (
      ((data.isHoujin === '1' && !data.houjinNmKj && !data.houjinNmKn) ||
        (data.isHoujin === '0' &&
          !data.kojinNmKjMei &&
          !data.kojinNmKjSei &&
          !data.kojinNmKnMei &&
          !data.kojinNmKnSei)) &&
      (!data.address1 && !data.addressPrefCd && !data.zipNo1 && !data.zipNo2)
    ) {
      res = true;
    }
    return res;
  }

  setKanriNo(kanriNo: string) {
    this.chosenKanriNo.next(kanriNo);
  }

  getcompanyInfoListOrderForPrint(value: any): Observable<CompanyPrintInfo[]> {
    const path = `${apiUrl}` + `/orders/${value}/companyInfoListForPrint`;
    // const path = `http://192.168.1.55:19401/ckj/v1` + `/estimates/${id}`;
    const queryParameters = new URLSearchParams();
    this.defaultHeaders.append(
      'Content-Type',
      'application/json;charset=utf-8'
    );
    const headerParams = this.defaultHeaders;
    headerParams.set('auth', this._data.token);
    const requestOptions: RequestOptionsArgs = {
      method: 'GET',
      headers: headerParams,
      search: queryParameters
    };
    return this._http
      .request(path, requestOptions)
      .map((response: Response) => {
        if (response.status === 204) {
          return undefined;
        } else if (response.status == 401) {
          this.deleteToken();
        } else {
          return response.json();
        }
      })
      .catch(this.handleError.bind(this));
  }

  getdefaultCompanyInfoForPrintOrder(value: any): Observable<CompanyPrintInfo> {
    const path = `${apiUrl}` + `/orders/${value}/defaultCompanyInfoForPrint`;
    // const path = `http://192.168.1.55:19401/ckj/v1` + `/estimates/${id}`;
    const queryParameters = new URLSearchParams();
    this.defaultHeaders.append(
      'Content-Type',
      'application/json;charset=utf-8'
    );
    const headerParams = this.defaultHeaders;
    headerParams.set('auth', this._data.token);
    const requestOptions: RequestOptionsArgs = {
      method: 'GET',
      headers: headerParams,
      search: queryParameters
    };
    return this._http
      .request(path, requestOptions)
      .map((response: Response) => {
        if (response.status === 204) {
          return undefined;
        } else if (response.status == 401) {
          this.deleteToken();
        } else {
          return response.json();
        }
      })
      .catch(this.handleError.bind(this));
  }

  resetHopData(
    delData,
    hanbaiForShow,
    hanbaitenPreSave,
    hanbaiSelLoan,
    hanbaiEditName,
    delForShow,
    delPreSave,
    delLoan,
    delName,
    taxRate,
    hopobj
  ) {
    if (delData) {
      hanbaiForShow = [...delForShow];
      hanbaitenPreSave = [...delPreSave];
      hanbaiSelLoan = [...delLoan];
      hanbaiEditName = [...delName];
    }

    if (
      hanbaiForShow &&
      hanbaiForShow.length !== 0 &&
      hanbaitenPreSave.length !== 0
    ) {
      let save;
      let indexSave;

      hanbaitenPreSave.forEach((pre, i) => {
        if (pre.id) {
          indexSave = hanbaiForShow.findIndex(val => val.id == pre.id);
          hanbaiSelLoan = hanbaiSelLoan.filter((val, i) => i != indexSave);
          hanbaiEditName = hanbaiEditName.filter((val, i) => i != indexSave);
          save = hanbaiForShow.filter(val => val.id != pre.id);
          hanbaiForShow = [...save];
        }
      });
    }

    if (hanbaiForShow && hanbaiForShow.length != 0) {
      for (let k = 0; k < hanbaiForShow.length; k++) {
        if (hanbaiEditName && hanbaiEditName.length != 0) {
          if (hanbaiForShow[k]['editName']) {
            hanbaiForShow[k]['editName'] = hanbaiEditName[k]['editName'];
          }
          hanbaiForShow[k]['shutokuzei'] = hanbaiEditName[k]['shutokuzei'];

          if (hanbaiEditName[k]['priceZk'] && hanbaiEditName[k]['priceZn']) {
            this.planservice
              .calCulateZeinukiToZeikomi(
                !hanbaiEditName[k]['priceZn']
                  ? 0
                  : hanbaiEditName[k]['priceZn'],
                taxRate
              )
              .subscribe((zk: Zk) => {
                if (zk) {
                  hanbaiEditName[k]['priceZk'] = zk.zeikomi;
                  hanbaiForShow[k]['priceZk'] = hanbaiEditName[k]['priceZk'];
                  this.planservice
                    .calCulateZeikomiToZeinuki(
                      !hanbaiEditName[k]['priceZk']
                        ? 0
                        : hanbaiEditName[k]['priceZk'],
                      taxRate
                    )
                    .subscribe((zn: Zn) => {
                      if (zn) {
                        hanbaiEditName[k]['priceZn'] = zn.zeinuki;
                        hanbaiForShow[k]['priceZn'] =
                          hanbaiEditName[k]['priceZn'];
                      }
                    });
                }
              });
          }
        }
      }
    }

    hopobj.items = [...hanbaiForShow];
    this.setHunbaiOptionSelected.next(hanbaiForShow);
    this.setDataHop(hopobj);
    this.hopShowDialog.next(false);
  }

  getRecycleFeeDetail(
    prefCd: string,
    makerCd: string,
    modelCd: string,
    kaiseiYm: string,
    gradeCd: string
  ): Observable<RecycleFeeDetail> {
    const path =
      `${apiUrlcommon}` +
      `/newcar/recycleFeeDetail?q=prefCd=${prefCd}` +
      `,makerCd=${makerCd}` +
      `,modelCd=${modelCd}` +
      `,kaiseiYm=${kaiseiYm}` +
      `,gradeCd=${gradeCd}`;
    const queryParameters = new URLSearchParams();
    const headerParams = this.defaultHeaders;
    headerParams.set('auth', this._data.token);
    const requestOptions: RequestOptionsArgs = {
      method: 'GET',
      headers: headerParams,
      search: queryParameters
    };
    return this._http
      .request(path, requestOptions)
      .map((response: Response) => {
        if (response.status === 204) {
          return undefined;
        } else if (response.status === 401) {
          this.deleteToken();
        } else {
          return response.json();
        }
      })
      .catch(this.handleError.bind(this));
  }

  gradesSetFlags(flag: any) {
    if (this._data.totalCarInPlan > 1) {
      if (this.statusgradeCar === 1) {
        this.allFlags1 = flag;
      } else if (this.statusgradeCar === 2) {
        this.allFlags2 = flag;
      } else if (this.statusgradeCar === 3) {
        this.allFlags3 = flag;
      }
    }
  }

  gradesGetFlags() {
    if (this.statusgradeCar === 1) {
      return this.allFlags1;
    } else if (this.statusgradeCar === 2) {
      return this.allFlags2;
    } else if (this.statusgradeCar === 3) {
      return this.allFlags3;
    }
    return null;
  }

  gradesResetFlags() {
    this.allFlags1 = null;
    this.allFlags2 = null;
    this.allFlags3 = null;
  }
  set etc(data: Etc) {
    if (this.statusgradeCar === 2) {
      this.etc2 = data;
    } else if (this.statusgradeCar === 3) {
      this.etc3 = data;
    }
    this.etc1 = data;
  }

  get etc(): Etc {
    if (this.statusgradeCar === 2) {
      return this.etc2;
    } else if (this.statusgradeCar === 3) {
      return this.etc3;
    }
    return this.etc1;
  }

  set remarkBikou1(data: Kyoten) {
    if (this.statusgradeCar === 2) {
      this.remarkBikou2_1 = data;
    } else if (this.statusgradeCar === 3) {
      this.remarkBikou3_1 = data;
    } else {
      this.remarkBikou1_1 = data;
    }
  }

  set remarkBikou2(data: Kyoten) {
    if (this.statusgradeCar === 2) {
      this.remarkBikou2_2 = data;
    } else if (this.statusgradeCar === 3) {
      this.remarkBikou3_2 = data;
    } else {
      this.remarkBikou1_2 = data;
    }
  }

  get remarkBikou1() {
    if (this.statusgradeCar === 2) {
      return this.remarkBikou2_1;
    } else if (this.statusgradeCar === 3) {
      return this.remarkBikou3_1;
    } else {
      return this.remarkBikou1_1;
    }
  }

  get remarkBikou2() {
    if (this.statusgradeCar === 2) {
      return this.remarkBikou2_2;
    } else if (this.statusgradeCar === 3) {
      return this.remarkBikou3_2;
    } else {
      return this.remarkBikou1_2;
    }
  }

  resetEtc() {
    this.etc1 = {};
    this.etc2 = {};
    this.etc3 = {};

    this.remarkBikou1_1 = null;
    this.remarkBikou1_2 = null;
    this.remarkBikou2_1 = null;
    this.remarkBikou2_2 = null;
    this.remarkBikou3_1 = null;
    this.remarkBikou3_2 = null;
  }
  getdefaultPaymentSetting(sharyouKbn: number) {
    const kyotenCd = this._data.kyotenCd;
    if (!sharyouKbn) {
      sharyouKbn = 1;
    }
    const path = `${apiUrl}/plan/defaultPaymentSetting?q=kyotenCd=${kyotenCd},sharyouKbn=${sharyouKbn}`;
    const queryParameters = new URLSearchParams();
    const headerParams = this.defaultHeaders;
    headerParams.set('auth', localStorage.getItem('token'));
    const requestOptions: RequestOptionsArgs = {
      method: 'GET',
      headers: headerParams,
      search: queryParameters
    };
    return this._http
      .request(path, requestOptions)
      .map((response: Response) => {
        if (response.status === 204) {
          return undefined;
        } else if (response.status === 401) {
          this.deleteToken();
        } else {
          return response.json();
        }
      })
      .catch(this.handleError.bind(this));
  }

  disabledHontaiPrice(isNeCar: boolean, sharyouHontaiPriceLockKbn: number) {
    // mitsumoriChumon || car?.sharyouKbn == 1 || ((car?.sharyouKbn == 2 || car?.sharyouKbn == 3) &&
    // dataEnvironmentSetting?.sharyouHontaiPriceLockKbn == 1)) && !canChangeCarType
    if (isNeCar) {
      return true;
    }
    if (this.planType.mitsumoriChumon) {
      return true;
    }
    if (sharyouHontaiPriceLockKbn === 1) {
      return true;
    }
    return false;
  }

  sendSaveType(saveType: number, isConfirm: boolean) {
    this.saveSubject.next({saveType, isConfirm});
    if (this._data.getPaymentMethod() === 2) {
      this._data.isCalcLoanComplete.next(false);
      let n = 0;
      const loan1 = this.planservice.loanOneShinpanCode.getValue();
      const loan2 = this.planservice.loanOneShinpanCode.getValue();
      if (loan1) {
        n++;
      }
      if (loan2) {
        n++;
      }
      this._data.nLoanPlan = n;
      this._data.nLoanCalc = 0;
    }
  }

  deleteEstimates(mitsumoriCd: string): Observable<any> {
    const url = `${apiUrl}/estimates//${mitsumoriCd}`;
    this.defaultHeaders.append(
      'Content-Type',
      'application/json;charset=utf-8'
    );
    const headerParams = this.defaultHeaders;
    headerParams.set('auth', this._data.token);
    const requestOptions: RequestOptionsArgs = {
      method: 'DELETE',
      headers: headerParams
    };
    return this._http
      .request(url, requestOptions)
      .map((response: Response) => {
        if (response.status === 200) {
          return true;
        } else if (response.status === 401) {
          this.deleteToken();
        } else {
          return false;
        }
      })
      .catch(this.handleError.bind(this));
  }

  cutName(itemNm: string) {
    const length = this._util.getUTF8Length(itemNm, 100);
    if (length.count > 100) {
      itemNm = itemNm.substr(0, length.strCount);
    }
    return itemNm;
  }

  mapDopItemForSave(data: any) {
    return {
      isHikazei: data.isHikazei,
      itemNm: this.cutName(data.itemNm),
      itemCd: data.itemCd,
      itemPrefCd: data.itemPrefCd,
      priceZk: data.priceZk,
      priceZn: data.priceZn,
      shutokuzei: data.shutokuzei,
      itemEdaban: data.itemEdaban
    };
  }

  getShutokuzeiLabel(yoteiYm: any, defaultText: string = '取得税') {
    let label = defaultText;
    if (this._data.getPaymentMethod() === 3) { // lease
      label = this.checktourokuYMGetShutokuzeiLabel(yoteiYm);
    } else {
      const taxvaluedata = this.taxvaluedata.getValue();
      if (taxvaluedata) {
        label = this.checktourokuYMGetShutokuzeiLabel(taxvaluedata.sharyouTourokuYm, defaultText);
      }
    }
    return label;
  }
  checktourokuYMGetShutokuzeiLabel(tourokuYm: string, defaultText: string = '取得税') {
    const date1 = new Date('2019 Oct 01');
    if (tourokuYm) {
      const torokuDate = this.getDate(tourokuYm, 'YYYYMM');
      if (torokuDate >= date1) {
        return '環境性能割';
      }
    }
    return defaultText;
  }

  getMsgError(err: any) {
    if (err.rsltCode) {
      const code = Number(err.rsltCode.replace(/[^0-9]/g, ''));
      if (code < 500 && err.rsltComment) {
        return err.rsltComment;
      } else {
        return 'システムエラーが発生しました。';
      }
    }
  }

  downloadPolicy(fileName: string) {
    const headers = new Headers({ 'Content-Type': 'application/pdf' });
    return this._http
      .get(`/assets/plan/${fileName}.pdf`, {
        headers: headers,
        responseType: ResponseContentType.Blob
      })
      .map(response => response.blob())
      .catch(this.handleError.bind(this));
  }

  getZaikoInquiry(id: string, monthlyLeaseKbn: string, dataEnvironmentSetting: EnvironmentSetting) {
    const path = `${apiUrl}/btob/pdfZaikoInquiry/${id}`;
    let q = '';
    q = '?monthlyLease=' + monthlyLeaseKbn;
    if (dataEnvironmentSetting) {
      q += '&additionalPrice=' + dataEnvironmentSetting.carPriceAdjustmentForKei
       + ',' + dataEnvironmentSetting.carPriceAdjustmentForFutsuu + ','
       + dataEnvironmentSetting.carPriceAdjustmentForImport;
    }
    const headers = new Headers();
    headers.append('Content-Type', 'application/pdf');
    headers.set('auth', this._data.token);
    return this._http
      .get(path + q, { headers: headers, responseType: ResponseContentType.Blob })
      .map(response => response.blob())
      .catch(this.handleError.bind(this));
  }

  getZaikoRakusatsu(id: string, monthlyLeaseKbn: string, dataEnvironmentSetting: EnvironmentSetting) {
    const path = `${apiUrl}/btob/pdfZaikoRakusatsu/${id}`;
    let q = '';
    q = '?monthlyLease=' + monthlyLeaseKbn;
    if (dataEnvironmentSetting) {
      q += '&additionalPrice=' + dataEnvironmentSetting.carPriceAdjustmentForKei
       + ',' + dataEnvironmentSetting.carPriceAdjustmentForFutsuu + ','
       + dataEnvironmentSetting.carPriceAdjustmentForImport;
    }
    const headers = new Headers();
    headers.append('Content-Type', 'application/pdf');
    headers.set('auth', this._data.token);
    return this._http
      .get(path + q, { headers: headers, responseType: ResponseContentType.Blob })
      .map(response => response.blob())
      .catch(this.handleError.bind(this));
  }
}



// WEBPACK FOOTER //
// ./src/app/plan/service/plan-main.service.ts